// src/components/CoverageDiagnosis/CoverageDiagnosis.tsx
import { useEffect as useEffect3, useState as useState2 } from "react";
import { Button as Button4, Modal, Text as Text4 } from "@simplybusiness/mobius";

// src/components/CoverageDiagnosis/DynamicContent/DynamicContent.tsx
import { useState } from "react";
import { Container, Text as Text3 } from "@simplybusiness/mobius";

// src/components/PricingNudge/logos/moneysupermarket.ts
var msmLogo = () => {
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 1020.58 127.65" width="250px">
      <defs>
        <path id="a" d="M1020.58 20.69v15.76h-14.88v89.08h-18.95V36.45H971.7V20.69h48.88zm-879.22 13.1c2.06 4.84 3.1 10.98 3.1 18.42v41.26c0 7.44-1.04 13.7-3.1 18.77-2.07 5.08-5.2 8.92-9.39 11.51-4.19 2.6-9.42 3.9-15.67 3.9-6.02 0-11.13-1.3-15.32-3.9-4.19-2.6-7.38-6.4-9.56-11.42-2.19-5.02-3.28-11.3-3.28-18.86V52.21c0-7.32 1.09-13.43 3.28-18.33 2.18-4.9 5.43-8.68 9.74-11.33 4.31-2.66 9.36-3.98 15.14-3.98 6.26 0 11.48 1.33 15.67 3.98 4.2 2.65 7.33 6.4 9.39 11.24zm-15.49 15.23c0-3.19-.35-5.81-1.06-7.88-.71-2.06-1.74-3.66-3.1-4.78s-3.16-1.68-5.4-1.68c-2.01 0-3.66.56-4.96 1.68-1.3 1.12-2.33 2.72-3.1 4.78-.77 2.07-1.15 4.69-1.15 7.88v47.82c0 3.43.38 6.17 1.15 8.23.77 2.07 1.8 3.6 3.1 4.61 1.3 1 2.95 1.5 4.96 1.5 2.24 0 4.01-.5 5.31-1.5 1.3-1 2.33-2.54 3.1-4.61.77-2.06 1.15-4.81 1.15-8.23V49.02zm794.17 76.51h43.39v-16.47h-24.44V79.31h22.14V63.72h-22.14v-27.1h24.44V20.69h-43.39v104.84zM191.52 71.69l-.08 8.66-17.81-59.66h-20.01v104.84h18.24V66.67l17.71 58.86h20.01V20.69h-18.24l.18 51zm321.07-40.38c2.06 3.78 3.1 8.62 3.1 14.52V67.8c0 6.02-1 10.98-3.01 14.88-2.01 3.9-4.84 6.7-8.5 8.41s-8.09 2.57-13.28 2.57h-9.39v31.88h-18.77V20.69h27.63c5.19 0 9.68.83 13.46 2.48 3.77 1.65 6.69 4.37 8.76 8.14zm-15.85 14.17c0-2.71-.71-4.9-2.13-6.55-1.42-1.65-3.78-2.48-7.08-2.48h-6.02v40.91h6.02c3.3 0 5.67-.8 7.08-2.39 1.42-1.59 2.13-3.92 2.13-7V45.48zm-277.59 80.05h43.39v-16.47H238.1V79.31h22.14V63.72H238.1v-27.1h24.44V20.69h-43.39v104.84zm305.7 0h43.39v-16.47H543.8V79.31h22.14V63.72H543.8v-27.1h24.44V20.69h-43.39v104.84zM914.02 20.69h-21.07l-18.59 49.13V20.87h-18.59v104.66h18.59V99.2l8.28-12.82 12.27 39.15h20.9l-20.88-59.37 19.09-45.47zM297.14 74.35l-9.12-53.66h-19.48l19.13 75.97v28.87h18.77V96.66l19.48-75.97h-19.13l-9.65 53.66zm473.25-53.48l16.82 104.66h-19.13l-2.43-18.06h-19.02l-2.46 18.06H725.4l16.65-104.66h28.34zm-6.89 70.48l-6.92-51.53h-.71l-7.03 51.53h14.66zm-328.92 8.32c0 2.6-.3 4.72-.89 6.38-.59 1.66-1.51 2.92-2.74 3.81-1.24.89-2.74 1.33-4.52 1.33-2.36 0-4.1-.44-5.22-1.33-1.12-.89-1.98-2.15-2.57-3.81-.59-1.65-.89-3.78-.89-6.38V20.69H398.8v76.86c0 6.73 1 12.31 3.01 16.74 2.01 4.43 5.02 7.76 9.03 10.01 4.01 2.24 9.21 3.36 15.58 3.36 6.02 0 11.01-1.18 14.96-3.54 3.95-2.36 6.91-5.72 8.85-10.09 1.95-4.37 2.92-9.86 2.92-16.47V20.69h-18.59v78.98zm411.61-55.25v16.12c0 5.31-1.15 9.74-3.45 13.28a20.775 20.775 0 01-5.61 5.76l-.06-.02c.74.49 1.46 1.01 2.13 1.58 4.66 3.96 7 9.89 7 17.8v26.59h-18.95V92.59c0-2.36-.65-4.28-1.95-5.76-1.3-1.47-3.43-2.21-6.38-2.21h-6.91v40.91h-18.77V20.69h26.92c8.03 0 14.37 1.98 19.04 5.93 4.66 3.96 6.99 9.89 6.99 17.8zm-27.27 25.15c2.95 0 5.07-.74 6.38-2.21 1.3-1.47 1.95-3.51 1.95-6.11V44.42c0-2.36-.65-4.28-1.95-5.76-1.3-1.47-3.43-2.21-6.38-2.21h-6.91v33.12h6.91zM630.75 44.42v16.12c0 5.31-1.15 9.74-3.45 13.28a20.775 20.775 0 01-5.61 5.76l-.06-.02c.74.49 1.46 1.01 2.13 1.58 4.66 3.96 7 9.89 7 17.8v26.59H611.8V92.59c0-2.36-.65-4.28-1.95-5.76-1.3-1.47-3.43-2.21-6.38-2.21h-6.91v40.91H577.8V20.69h26.92c8.03 0 14.37 1.98 19.04 5.93 4.66 3.96 6.99 9.89 6.99 17.8zm-27.27 25.15c2.95 0 5.07-.74 6.38-2.21 1.3-1.47 1.95-3.51 1.95-6.11V44.42c0-2.36-.65-4.28-1.95-5.76-1.3-1.47-3.43-2.21-6.38-2.21h-6.91v33.12h6.91zm-563.99-7.1L24.9 1.95H0v123.58h19.3l-1.59-87.45 21.78 78.54 21.78-78.54-1.59 87.45h19.3V1.95h-24.9L39.49 62.47zm339.52-1.12c-3.48-2.83-21.02-11.83-22.49-12.84-1.48-1-2.69-2.36-3.63-4.07-.95-1.71-1.48-3.92-1.59-6.64V25.32c0-1.53.35-2.92 1.06-4.16a8.416 8.416 0 012.92-3.01c1.24-.77 2.92-1.15 5.05-1.15 3.78 0 6.43 1.09 7.97 3.28 1.53 2.19 2.3 5.17 2.3 8.94v11.23h18.42V29.22c0-9.21-2.45-16.38-7.35-21.52-4.9-5.14-12.01-7.7-21.34-7.7-5.79 0-10.8.97-15.05 2.92s-7.53 4.9-9.83 8.85c-2.3 3.96-3.45 8.47-3.45 13.55v12.47c0 5.31.74 9.71 2.21 13.19 1.48 3.48 3.6 6.44 6.38 8.85 2.77 2.42 21.78 12.4 23.73 13.64 1.95 1.24 3.42 2.86 4.43 4.87 1 2.01 1.51 4.72 1.51 8.15v13.71c0 3.07-.8 5.58-2.39 7.53-1.59 1.95-3.98 2.92-7.17 2.92-2.72 0-4.87-.59-6.46-1.77-1.59-1.18-2.75-2.77-3.45-4.78-.71-2.01-1.06-4.13-1.06-6.38V85.25h-18.95v12.47c0 6.49 1.12 11.98 3.36 16.47 2.24 4.49 5.61 7.85 10.09 10.09 4.49 2.24 9.98 3.36 16.47 3.36 5.55 0 10.63-1.12 15.23-3.36 4.6-2.24 8.03-5.37 10.27-9.39 2.24-4.01 3.36-8.74 3.36-14.17v-14.6c0-5.67-.89-10.51-2.66-14.52-1.78-3.99-4.41-7.42-7.89-10.25zm300.9 1.12l-14.6-60.52h-24.9v123.58h19.3l-1.59-87.45 21.78 78.54 21.78-78.54-1.59 87.45h19.3V1.95h-24.9l-14.58 60.52z"/>
      </defs>
      <radialGradient id="b" cx="504.947" cy="63.826" r="500.402" gradientUnits="userSpaceOnUse">
        <stop offset="0" stop-color="#604389"/>
        <stop offset=".999" stop-color="#491770"/>
      </radialGradient>
      <use xlink:href="#a" overflow="visible" fill="url(#b)"/>
    </svg>
  `;
  return tempDiv.firstElementChild;
};

// src/utils/utils.ts
var convertNudgeToMSM = () => {
  const close = document.body.querySelector(
    "#priceNudgeIntervention .mobius-modal__close"
  );
  const cta = document.body.querySelector(
    ".mobius-interventions__pricing-nudge-cta"
  );
  const text = document.body.querySelector(
    ".mobius-interventions__pricing-nudge-text"
  );
  if (close) close.style.setProperty("color", "#590f85");
  if (cta) cta.style.setProperty("background-color", "#590f85");
  if (text) text.style.setProperty("color", "black");
};
var convertIPtoMSM = () => {
  const sbIpAppElement = document.querySelector("#sb-ip-app");
  const shadowRoot = sbIpAppElement ? sbIpAppElement.shadowRoot : null;
  if (shadowRoot) {
    shadowRoot.host.style.setProperty(
      "--color-azure-500",
      "#590f85"
    );
    const existingSvg = shadowRoot.querySelector("header > svg");
    if (existingSvg) {
      existingSvg.replaceWith(msmLogo());
    }
  }
};
var chopinEnvironment = () => {
  if (globalThis.window) {
    const envMetaElement = window.document ? window.document.querySelector('meta[name="env"]') : null;
    return envMetaElement?.getAttribute("content") || "development";
  }
  return "development";
};

// src/constants/constants.ts
var AIRBRAKE_PROJECT_ID = 596261;
var AIRBRAKE_PROJECT_KEY = "087fa89dae55f9f3c3454d6eb13bd6e3";
var IDM_POST_OPTIONS = {
  method: "POST",
  headers: {
    Accept: "application/json; charset=utf-8",
    "Content-Type": "application/json; charset=utf-8"
  }
};
var DEFAULT_POLLING_INTERVAL = 5e3;
var MAX_IDLE_TIME = 5e3;
var IDM_API_URLS = (ENV_OVERRIDE = void 0) => {
  const environment = ENV_OVERRIDE || chopinEnvironment();
  if (environment === "production") {
    return "https://intervention-decision-mechanism.api.simplybusiness.com/v1";
  }
  if (["test", "staging"].includes(environment)) {
    return "https://intervention-decision-mechanism-staging.api.simplybusiness.com/v1";
  }
  return "http://localhost:1415/v1";
};

// src/utils/inactivity-service.ts
var InactivityService = class {
  constructor(callback) {
    this.makeUserInactive = () => {
      this.userActive = false;
      this.setInactiveCallback(true);
      this.removeListeners(this.renewTimeout);
      this.addListeners(this.makeUserActive);
    };
    this.makeUserActive = () => {
      this.userActive = true;
      this.setInactiveCallback(false);
      this.removeListeners(this.makeUserActive);
      this.start();
    };
    this.renewTimeout = () => {
      clearTimeout(this.timeoutId);
      if (this.userActive) this.timeoutId = this.createTimeout();
    };
    this.inactivityTime = MAX_IDLE_TIME;
    this.setInactiveCallback = callback;
    this.timeoutId = void 0;
    this.userActive = true;
  }
  start() {
    this.timeoutId = this.createTimeout();
    this.addListeners(this.renewTimeout);
  }
  stop() {
    clearTimeout(this.timeoutId);
    this.removeListeners(this.renewTimeout);
    this.removeListeners(this.makeUserActive);
  }
  createTimeout() {
    return setTimeout(this.makeUserInactive, this.inactivityTime);
  }
  addListeners(callback) {
    window.addEventListener("mousemove", callback);
    window.addEventListener("keydown", callback);
    window.addEventListener("scroll", callback);
    window.addEventListener("click", callback);
  }
  removeListeners(callback) {
    window.removeEventListener("mousemove", callback);
    window.removeEventListener("keydown", callback);
    window.removeEventListener("scroll", callback);
    window.removeEventListener("click", callback);
  }
};
var inactivity_service_default = InactivityService;

// src/airbrake/index.ts
import { Notifier } from "@airbrake/browser";
var notifierInstance;
var fakeAirbrake = {
  notify: console.error
};
var dontUseAirbrake = () => {
  const { NODE_ENV } = process.env;
  const { hostname } = globalThis.location || {};
  return NODE_ENV === "test" || NODE_ENV === "development" || !hostname?.includes("quote.") || !hostname?.includes("quote-staging.");
};
function getAirbrake() {
  if (typeof process !== "undefined" && dontUseAirbrake()) return fakeAirbrake;
  if (!notifierInstance) {
    notifierInstance = new Notifier({
      projectId: AIRBRAKE_PROJECT_ID,
      projectKey: AIRBRAKE_PROJECT_KEY,
      environment: "development",
      instrumentation: {
        onerror: false,
        // turn off reporting of window's error event
        unhandledrejection: false
        // turn off window listener for Promise rejections
      }
    });
  }
  return notifierInstance;
}

// src/utils/updateInterventionStatus.ts
var airbrake = getAirbrake();
async function updateInterventionStatus(userID, interventionName, site) {
  try {
    const response = await fetch(`${IDM_API_URLS()}/intervention/shown`, {
      ...IDM_POST_OPTIONS,
      body: JSON.stringify({
        system_user_id: userID,
        intervention_name: interventionName,
        site
      })
    });
    if (response.ok) return true;
    return false;
  } catch (error) {
    console.error("Error updating intervention status.", error);
    void airbrake.notify({
      error,
      params: {
        source: "mobius-interventions",
        interventionName,
        userId: userID,
        site
      }
    });
    return false;
  }
}

// src/utils/tradeBasedCovers.ts
var tradeCovers = {
  "Accident investigator": ["Legal expenses", "Personal accident"],
  Accountant: ["Legal expenses", "Excess sum insured"],
  "Accumulator/Battery Manufacturing": [
    "Legal expenses",
    "Include stock online"
  ],
  "Acoustic engineer": ["Personal accident", "Legal expenses"],
  "Actor (excluding stunt work)": ["Personal accident", "Include contents"],
  Acupuncture: ["Personal accident", "Excess sum insured"],
  Administrator: ["Legal expenses", "Include contents"],
  "Advertising agent": ["Legal expenses", "Include contents"],
  "Aerial & satellite dish erectors - residential only": [
    "Personal accident",
    "Include tools"
  ],
  "Aerial erector - non residential": [
    "Include contents",
    "Excess sum insured"
  ],
  "Agricultural Equipment Manufacturers": ["Include stock online"],
  "Agricultural contractors (excluding crop spraying)": [
    "Personal accident",
    "Legal expenses"
  ],
  "Air conditioning installation": ["Personal accident", "Legal expenses"],
  "Alarm installers": ["Personal accident", "Legal expenses"],
  "Animal breeder": ["Legal expenses", "Excess sum insured"],
  "Animal owners club": ["Excess sum insured"],
  "Antique Book Shop": ["Include stock online", "Include contents"],
  "Antique Furniture Shop": ["Include contents", "Include stock online"],
  "Antique Shop": ["Include stock online", "Include contents"],
  "Antique dealer": ["Include stock online", "Legal expenses"],
  "Antiques & collectables in Shops & retail": ["Excess sum insured"],
  "Appliance repairers - domestic": ["Excess sum insured", "Legal expenses"],
  "Appliances Shop": ["Include contents", "Include stock online"],
  "Aquarium / Tropical Fish Shop": ["Legal expenses", "Business interruption"],
  Arbitrator: ["Excess sum insured", "Include contents"],
  Architect: ["Legal expenses", "Include contents"],
  "Architect technician": ["Legal expenses", "Excess sum insured"],
  "Army & Navy Shop": ["Legal expenses", "Include stock online"],
  Aromatherapy: ["Legal expenses", "Include stock online"],
  "Art dealer": ["Legal expenses", "Include stock online"],
  "Art gallery": ["Legal expenses", "Excess sum insured"],
  Artist: ["Include stock online", "Include contents"],
  "Artist Studio": ["Include contents", "Include stock online"],
  "Artistic painters, sculptors or potters": [
    "Include stock online",
    "Personal accident"
  ],
  "Artists Materials": ["Include stock online"],
  "Artists studio": ["Include contents", "Legal expenses"],
  "Arts & Crafts Ex. Precious Stones / Gift Shop": [
    "Include stock online",
    "Include contents"
  ],
  "Arts & Crafts Shop": ["Include stock online", "Include contents"],
  "Arts & crafts in Shops & retail": ["Excess sum insured", "Include contents"],
  "Au pair": ["Legal expenses", "Excess sum insured"],
  Auctioneer: ["Personal accident", "Legal expenses"],
  "Audio Visual Media Wholesaling": ["Include stock online"],
  "Auditor (non-accountant)": ["Legal expenses", "Personal accident"],
  Author: ["Legal expenses", "Include stock online"],
  "Baby Goods Shop": ["Legal expenses", "Include stock online"],
  "Babywear Shop": ["Legal expenses", "Include stock online"],
  Bailiff: ["Legal expenses", "Excess sum insured"],
  Baker: ["Include contents", "Legal expenses"],
  Bakery: ["Include contents", "Legal expenses"],
  "Bakery / Caf\xE9": ["Include contents", "Include stock online"],
  "Bakery Produce Manufacturing": ["Legal expenses", "Include stock online"],
  "Balloons / Party Supplies": ["Include contents", "Include stock online"],
  "Balloons and party supplies in Shops & retail": ["Include contents"],
  Barber: ["Include tools", "Personal accident"],
  "Barber / Beauty Salon": ["Include contents", "Personal accident"],
  "Barber Shop": ["Include contents", "Personal accident"],
  "Barber in Shops & retail": ["Excess sum insured", "Include contents"],
  Barrister: ["Include contents", "Legal expenses"],
  "Bathroom & kitchen design": ["Legal expenses", "Personal accident"],
  "Bathroom Equipment Shop": ["Include contents", "Personal accident"],
  "Bathroom, bedroom & kitchen fitter": ["Legal expenses", "Personal accident"],
  Beautician: ["Legal expenses", "Include tools"],
  "Beauty Products": ["Include stock online", "Legal expenses"],
  "Beauty Salon": ["Include contents", "Include stock online"],
  "Beauty Salon / Hairdressing": ["Include contents", "Include stock online"],
  "Beauty Shop": ["Include contents", "Include stock online"],
  "Beauty products in Shops & retail": ["Excess sum insured"],
  "Beauty salon & hairdressing in Shops & retail": [
    "Excess sum insured",
    "Include contents"
  ],
  "Beauty salon in Shops & retail": ["Excess sum insured", "Include contents"],
  "Bed & Breakfast - Licensed": ["Include stock online", "Include contents"],
  "Bed & Breakfast - Unlicensed": ["Include contents", "Personal accident"],
  "Bed Shop": ["Include stock online", "Legal expenses"],
  "Bedding Shop": ["Include stock online", "Include contents"],
  "Beer Warehousing": ["Legal expenses", "Include stock online"],
  "Bicycle Rental Shop": ["Include stock online", "Business interruption"],
  "Bicycle Repair Shop": ["Include stock online", "Include contents"],
  "Bicycle Repair Shop in Shops & retail": [
    "Excess sum insured",
    "Include contents"
  ],
  "Bicycle Shop": ["Include stock online", "Include contents"],
  "Bicycle repairs (including e-bikes)": ["Legal expenses", "Include tools"],
  "Blind / curtain makers & fitters": ["Personal accident", "Legal expenses"],
  "Book Manufacturers": ["Include stock online"],
  "Book in Shops & retail": ["Excess sum insured"],
  "Book keeper": ["Legal expenses", "Include contents"],
  "Bookmaker in Shops & retail": ["Excess sum insured"],
  Bookshop: ["Include stock online", "Include contents"],
  "Bookshop - Inc Second Hand": ["Include stock online"],
  "Boot & Shoe Shop": ["Include stock online", "Business interruption"],
  "Bottle (Plastic) Wholesalers": ["Include stock online"],
  "Breeder (animal)": ["Legal expenses", "Excess sum insured"],
  Brewery: ["Include buildings", "Include stock online"],
  "Bric A Brac": ["Include stock online", "Include contents"],
  Bricklayer: ["Personal accident", "Legal expenses"],
  "Bridal Shop": ["Include stock online", "Include contents"],
  "Bridal Shop in Shops & retail": ["Include contents", "Excess sum insured"],
  Builder: ["Personal accident", "Legal expenses"],
  "Builder - design only": ["Personal accident", "Legal expenses"],
  "Builder - private dwelling houses alteration & repair": [
    "Excess sum insured",
    "Legal expenses"
  ],
  "Builders & contractors in Industrial units": ["Excess sum insured"],
  "Builders Merchant": ["Legal expenses", "Personal accident"],
  "Building Material Wholesaling": ["Legal expenses", "Include stock online"],
  "Building Society in Shops & retail": ["Excess sum insured"],
  "Building services engineer": ["Legal expenses", "Personal accident"],
  Bungalow: ["Legal expenses", "Include contents"],
  "Burger Bar": ["Include contents", "Excess sum insured"],
  "Business analyst": ["Legal expenses", "Portable equipment"],
  "Business coach": ["Legal expenses", "Include contents"],
  "Business consultant": ["Legal expenses", "Portable equipment"],
  Butcher: ["Include contents", "Include stock online"],
  "Butcher & Greengrocer in Shops & retail": [
    "Excess sum insured",
    "Include contents"
  ],
  "Butcher & Grocer Unlicensed in Shops & retail": [
    "Include contents",
    "Excess sum insured"
  ],
  "Butcher / Greengrocer": ["Include contents", "Include stock online"],
  "Butcher / Grocer - Unlicensed": ["Include stock online", "Include contents"],
  "Butchers - Wholesale": ["Include stock online"],
  "Cable laying": ["Personal accident", "Excess sum insured"],
  Caf\u00E9: ["Include contents", "Include stock online"],
  "Caf\xE9 / Coffee Shop": ["Include contents", "Include stock online"],
  "Caf\xE9 / Gift Shop": ["Include stock online", "Legal expenses"],
  "Caf\xE9 / Licenced Premises": ["Include contents", "Include stock online"],
  "Caf\xE9 / Sandwich Bar": ["Include contents", "Legal expenses"],
  "Caf\xE9 / Take Away Food": ["Include contents", "Include stock online"],
  "Caf\xE9s - excluding deep fat frying in Food & drink": [
    "Excess sum insured",
    "Include contents"
  ],
  "Caf\xE9s - including deep fat frying in Food & drink": [
    "Excess sum insured",
    "Include contents"
  ],
  "Cake maker and decorator": ["Legal expenses", "Personal accident"],
  Calibration: ["Include tools"],
  Calligraphist: ["Excess sum insured", "Include stock online"],
  "Camera Shop": ["Include stock online", "Excess sum insured"],
  "Camping & Outdoor Shop": ["Legal expenses", "Include contents"],
  "Candle / wax melt maker": ["Legal expenses", "Include stock online"],
  "Car Accessory Dealing": ["Include buildings", "Include stock online"],
  "Car Accessory Shop": ["Legal expenses", "Include stock online"],
  "Car Accessory Shop in Shops & retail": ["Include contents"],
  "Car Entertainment System Shop": ["Legal expenses", "Excess sum insured"],
  "Car Parts & Accessories Shop": ["Include contents", "Include stock online"],
  "Car Parts & Accessories Shop in Shops & retail": ["Excess sum insured"],
  "Car Parts Shop": ["Include contents", "Include stock online"],
  "Car Stereo Shop - Including Fitting": ["Personal accident"],
  "Car park operator": ["Personal accident", "Legal expenses"],
  "Car valeter": ["Legal expenses", "Excess sum insured"],
  "Card & Bookshop": ["Include contents", "Include stock online"],
  Carer: ["Personal accident", "Legal expenses"],
  Caretaker: ["Personal accident", "Legal expenses"],
  Carpenter: ["Personal accident", "Legal expenses"],
  "Carpet Shop": ["Include stock online", "Include contents"],
  "Carpet Shop - Oriental Or Persian": ["Include contents"],
  "Carpet Warehouse": ["Legal expenses", "Include stock online"],
  "Carpet fitter": ["Legal expenses", "Personal accident"],
  "Carpet, upholstery & curtain cleaner": [
    "Include tools",
    "Excess sum insured"
  ],
  "Carpets in Shops & retail": ["Include contents"],
  Cartographer: ["Legal expenses"],
  "Cash & Carry": ["Include contents", "Business interruption"],
  "Catalogue goods distributor": ["Legal expenses", "Excess sum insured"],
  "Caterer - excluding mobile vans": ["Legal expenses", "Personal accident"],
  "Caterer - including mobile vans": ["Legal expenses", "Excess sum insured"],
  "Catering - Licensed": ["Include stock online"],
  "Cavity insulation": ["Include tools", "Personal accident"],
  "Cctv installation": ["Personal accident", "Legal expenses"],
  "Cd & Dvd Shop": ["Legal expenses"],
  "Ceiling contractors": ["Legal expenses", "Include contract works"],
  "Ceramics Shop": ["Include stock online", "Legal expenses"],
  "Chandelier Shop": ["Include contents", "Business interruption"],
  "Chandlery Shop": ["Include contents", "Legal expenses"],
  "Charity Shop": ["Legal expenses", "Include contents"],
  "Charity Shop in Shops & retail": ["Excess sum insured", "Include contents"],
  "Chartered valuer": ["Personal accident", "Legal expenses"],
  Chauffeur: ["Legal expenses", "Excess sum insured"],
  "Cheese Wholesalers": ["Include stock online"],
  Chef: ["Personal accident", "Legal expenses"],
  "Child minder": ["Legal expenses", "Personal accident"],
  "Children's Clothes Shop": ["Include stock online", "Include contents"],
  "Childrens entertainer": ["Legal expenses", "Include contents"],
  "Chimney sweep": ["Include tools", "Legal expenses"],
  "China / Glassware Retailing": ["Excess sum insured", "Include contents"],
  Chiropodist: ["Legal expenses", "Personal accident"],
  Chiropractor: ["Include contents", "Legal expenses"],
  "Chocolate Wholesalers": ["Include stock online", "Legal expenses"],
  Chocolatier: ["Include contents", "Legal expenses"],
  "Christmas Goods Shop": ["Excess sum insured", "Include contents"],
  "Christmas tree seller": ["Excess sum insured", "Legal expenses"],
  Church: ["Legal expenses", "Personal accident"],
  Cladding: ["Personal accident", "Excess sum insured"],
  "Cleaner - domestic": ["Personal accident", "Excess sum insured"],
  "Cleaner - drains": ["Personal accident", "Excess sum insured"],
  "Cleaner - office": ["Personal accident", "Legal expenses"],
  "Cleaner - other": ["Personal accident", "Legal expenses"],
  "Clerical / secretarial services": ["Legal expenses", "Include contents"],
  "Clock & Watch Repair": ["Include contents", "Include stock online"],
  "Clock & Watch Sales": ["Include stock online", "Legal expenses"],
  "Clothing Accessories Manufacturers (Fabric)": [
    "Include stock online",
    "Legal expenses"
  ],
  "Clothing Accessories Wholesalers (Fabric)": [
    "Include stock online",
    "Personal accident"
  ],
  "Clothing Accessories Wholesaling": [
    "Include stock online",
    "Include buildings"
  ],
  "Clothing Shop": ["Include stock online", "Include contents"],
  "Clothing Shop / Fashion Accessories": [
    "Include stock online",
    "Include contents"
  ],
  "Clothing Shop / Gift Shop": ["Include stock online", "Include contents"],
  "Clothing in Shops & retail": ["Excess sum insured", "Include contents"],
  "Coffee Merchant": ["Include stock online", "Legal expenses"],
  "Coffee Shop": ["Include contents", "Include stock online"],
  "Coffee Shop / Delicatessen": ["Business interruption", "Include contents"],
  "Coffee Shop / Gift Shop": ["Include contents", "Include stock online"],
  "Coffee Shop / Sandwich Bar": ["Include contents", "Legal expenses"],
  "Coffee Shop / Sandwich Bar in Shops & retail": [
    "Excess sum insured",
    "Include contents"
  ],
  "Coffee shop in Food & drink": ["Include contents", "Excess sum insured"],
  "Community action group": ["Legal expenses"],
  "Complaints handling": ["Legal expenses", "Excess sum insured"],
  "Complementary therapist": ["Legal expenses", "Personal accident"],
  "Computer - General / Computer Supplies": [
    "Legal expenses",
    "Include stock online"
  ],
  "Computer - General / Mobile Phone": [
    "Include stock online",
    "Legal expenses"
  ],
  "Computer Cabling": ["Excess sum insured", "Legal expenses"],
  "Computer Consumables Sales": ["Legal expenses", "Include contents"],
  "Computer Games Shop": ["Include contents", "Include stock online"],
  "Computer Hardware & Software Installation": [
    "Legal expenses",
    "Portable equipment"
  ],
  "Computer Programmer": ["Legal expenses", "Portable equipment"],
  "Computer Repair": ["Include contents", "Legal expenses"],
  "Computer Shop": ["Business interruption", "Include contents"],
  "Computer Software Customisation": ["Excess sum insured", "Legal expenses"],
  "Computer Software Developers": ["Legal expenses", "Excess sum insured"],
  "Computer Software Maintenance": ["Include contents", "Excess sum insured"],
  "Computer Software Sale (Third Party)": [
    "Legal expenses",
    "Excess sum insured"
  ],
  "Computer Software Testing": ["Portable equipment", "Legal expenses"],
  "Computers - Hardware Wholesaling": ["Include stock online"],
  "Concrete contractor": ["Personal accident", "Legal expenses"],
  "Confectionary Shop": ["Include stock online", "Include contents"],
  "Confectioners/Sweets in Shops & retail": [
    "Include contents",
    "Excess sum insured"
  ],
  "Confectionery (Sweets) Wholesalers": ["Legal expenses"],
  "Confectionery Manufacturing": ["Include stock online"],
  "Conference & exhibition organiser": ["Legal expenses", "Excess sum insured"],
  "Conservatory Retailer": ["Personal accident", "Legal expenses"],
  "Conservatory installers": ["Personal accident", "Include tools"],
  "Consultant - Computer Hardware": ["Legal expenses", "Excess sum insured"],
  "Consultant - Computer Software": ["Legal expenses", "Excess sum insured"],
  "Consultant - Database Management": ["Legal expenses", "Portable equipment"],
  "Consultant - Internet": ["Portable equipment", "Personal accident"],
  "Consultant - acoustic": ["Personal accident", "Legal expenses"],
  "Consultant - agriculture": ["Legal expenses", "Personal accident"],
  "Consultant - air conditioning": ["Include tools", "Personal accident"],
  "Consultant - automation": ["Legal expenses", "Personal accident"],
  "Consultant - aviation": ["Personal accident", "Legal expenses"],
  "Consultant - brand & design": ["Legal expenses", "Include contents"],
  "Consultant - brewers": ["Legal expenses", "Personal accident"],
  "Consultant - building": ["Legal expenses", "Excess sum insured"],
  "Consultant - business & management": [
    "Legal expenses",
    "Portable equipment"
  ],
  "Consultant - debt management": ["Legal expenses", "Excess sum insured"],
  "Consultant - drainage": ["Legal expenses", "Personal accident"],
  "Consultant - education": ["Legal expenses", "Include contents"],
  "Consultant - electronics": ["Legal expenses", "Personal accident"],
  "Consultant - employment": ["Legal expenses", "Excess sum insured"],
  "Consultant - energy (incl carbon credit trading)": [
    "Legal expenses",
    "Excess sum insured"
  ],
  "Consultant - energy conservation": ["Legal expenses", "Excess sum insured"],
  "Consultant - engineer": ["Legal expenses", "Excess sum insured"],
  "Consultant - environment": ["Personal accident", "Legal expenses"],
  "Consultant - environmental impact": ["Personal accident", "Legal expenses"],
  "Consultant - export": ["Legal expenses", "Personal accident"],
  "Consultant - financial": ["Legal expenses", "Excess sum insured"],
  "Consultant - fire safety": ["Legal expenses", "Excess sum insured"],
  "Consultant - fisheries": ["Legal expenses", "Excess sum insured"],
  "Consultant - food": ["Legal expenses", "Personal accident"],
  "Consultant - food safety & hygiene": ["Legal expenses", "Personal accident"],
  "Consultant - forestry": ["Personal accident", "Legal expenses"],
  "Consultant - hair and beauty": ["Legal expenses", "Personal accident"],
  "Consultant - health and safety": ["Legal expenses", "Personal accident"],
  "Consultant - heating": ["Personal accident", "Excess sum insured"],
  "Consultant - horticulture": ["Legal expenses", "Excess sum insured"],
  "Consultant - hotel and catering": ["Personal accident", "Legal expenses"],
  "Consultant - human resources": ["Legal expenses", "Excess sum insured"],
  "Consultant - image": ["Legal expenses", "Personal accident"],
  "Consultant - immigration": ["Legal expenses", "Excess sum insured"],
  "Consultant - import": ["Legal expenses", "Excess sum insured"],
  "Consultant - industrial": ["Legal expenses", "Excess sum insured"],
  "Consultant - insurance": ["Legal expenses", "Personal accident"],
  "Consultant - investment": ["Legal expenses", "Include contents"],
  "Consultant - legal": ["Legal expenses", "Include contents"],
  "Consultant - lifestyle": ["Legal expenses", "Personal accident"],
  "Consultant - lighting": ["Legal expenses", "Personal accident"],
  "Consultant - management & business": [
    "Legal expenses",
    "Portable equipment"
  ],
  "Consultant - marine": ["Include contents", "Legal expenses"],
  "Consultant - market research": ["Legal expenses", "Excess sum insured"],
  "Consultant - marketing and advertising": [
    "Legal expenses",
    "Include contents"
  ],
  "Consultant - occupational health": ["Legal expenses", "Personal accident"],
  "Consultant - pharmaceutical": ["Legal expenses", "Excess sum insured"],
  "Consultant - planning": ["Legal expenses", "Excess sum insured"],
  "Consultant - political": ["Legal expenses", "Include contents"],
  "Consultant - printing": ["Legal expenses", "Personal accident"],
  "Consultant - procurement": ["Legal expenses", "Excess sum insured"],
  "Consultant - public relations": ["Legal expenses", "Include contents"],
  "Consultant - research": ["Legal expenses", "Include contents"],
  "Consultant - risk management": ["Legal expenses", "Hospital cash plan"],
  "Consultant - science & research": ["Legal expenses", "Personal accident"],
  "Consultant - security": ["Legal expenses", "Excess sum insured"],
  "Consultant - tax": ["Legal expenses", "Excess sum insured"],
  "Consultant - telecommunications": ["Legal expenses", "Personal accident"],
  "Consultant - textiles": ["Legal expenses", "Include contents"],
  "Consultant - thermal & insulation": ["Personal accident", "Legal expenses"],
  "Consultant - traffic": ["Personal accident", "Legal expenses"],
  "Consultant - training": ["Legal expenses", "Include contents"],
  "Consultant - transport": ["Legal expenses", "Personal accident"],
  "Consultant - travel": ["Legal expenses", "Excess sum insured"],
  "Consultant - waste (incl broking)": ["Legal expenses", "Excess sum insured"],
  "Consultant - window": ["Excess sum insured", "Legal expenses"],
  "Contractors combined": ["Legal expenses", "Personal accident"],
  "Cookery Shop": ["Legal expenses", "Include contents"],
  "Cookery Shop in Shops & retail": ["Include contents"],
  "Cooking & ironing services - domestic only": [
    "Excess sum insured",
    "Legal expenses"
  ],
  "Cooking Ingredients": ["Include contents", "Include stock online"],
  Copywriter: ["Legal expenses", "Include contents"],
  "Corner Shop": ["Include stock online", "Include contents"],
  "Corner Shop / Off Licence": ["Include stock online", "Include contents"],
  "Cosmetics Shop": ["Include stock online", "Legal expenses"],
  Counsellor: ["Legal expenses", "Include contents"],
  Courier: ["Legal expenses", "Excess sum insured"],
  "Craft stall": ["Include stock online", "Legal expenses"],
  "Cultural interest group": ["Personal accident", "Excess sum insured"],
  "Curtain & blind maker in Shops & retail": ["Excess sum insured"],
  "Curtain And Blind Manufacturers": ["Include stock online", "Legal expenses"],
  "Curtain,blind makers & fitters": ["Legal expenses", "Excess sum insured"],
  "Curtains & Blinds Shop": ["Include stock online", "Include contents"],
  "Cutlery Shop": ["Include contents", "Excess sum insured"],
  "Cycle Shop": ["Include stock online", "Include contents"],
  "Cycles in Shops & retail": ["Excess sum insured"],
  "DIY Wholesalers": ["Include buildings"],
  "Dance instructor": ["Legal expenses", "Personal accident"],
  Dancer: ["Personal accident", "Excess sum insured"],
  "Data Processor": ["Legal expenses", "Portable equipment"],
  "Data analyst": ["Legal expenses", "Excess sum insured"],
  "Data engineer": ["Excess sum insured", "Portable equipment"],
  "Database Migration": ["Include contents", "Excess sum insured"],
  "Decorators Supplies": ["Personal accident", "Legal expenses"],
  Delicatessen: ["Include contents", "Include stock online"],
  "Delicatessen / Sandwich Bar": ["Include contents", "Include stock online"],
  "Delicatessen in Shops & retail": ["Excess sum insured"],
  "Delivery driver": ["Excess sum insured", "Personal accident"],
  "Dental technician": ["Legal expenses", "Personal accident"],
  Dentist: ["Legal expenses", "Personal accident"],
  "Dentist in Surgery": ["Excess sum insured", "Include contents"],
  "Department Store": ["Business interruption", "Personal accident"],
  "Desk Top Publisher": ["Legal expenses", "Personal accident"],
  "Detached house": ["Include contents", "Legal expenses"],
  Dietician: ["Include contents", "Legal expenses"],
  "Disc jockey": ["Include contents", "Excess sum insured"],
  "Discount Shop": ["Include stock online", "Legal expenses"],
  "Dispensing Chemist": ["Include contents", "Include stock online"],
  "Dispensing Chemist in Shops & retail": ["Excess sum insured"],
  Distillers: ["Include stock online", "Legal expenses"],
  "Diy Shop": ["Include stock online", "Include contents"],
  "Diy Shop - Excluding Timber": [
    "Include stock online",
    "Business interruption"
  ],
  "Diy Shop - Including Timber": ["Include stock online", "Include contents"],
  "Doctor (medical)": ["Legal expenses", "Personal accident"],
  "Dog Beautician": ["Include contents", "Personal accident"],
  "Dog walkers": ["Personal accident", "Legal expenses"],
  "Dolls House Shop": ["Include contents", "Legal expenses"],
  "Dolls Shop": ["Include stock online"],
  "Domestic Appliance Maintenance": ["Legal expenses"],
  "Domestic Appliance Shop": ["Include stock online", "Legal expenses"],
  "Domestic appliance repairers": ["Legal expenses", "Personal accident"],
  "Domestic services-ironing & cooking": ["Legal expenses", "Include contents"],
  "Door to door - franchise": ["Legal expenses", "Excess sum insured"],
  "Double Glazing & Window Retailer": ["Legal expenses", "Personal accident"],
  "Drain cleaners": ["Personal accident", "Legal expenses"],
  "Drapery, haberdashery, soft furnishings in Shops & retail": [
    "Excess sum insured"
  ],
  Draughtsman: ["Legal expenses", "Excess sum insured"],
  "Dress Agency": ["Legal expenses", "Personal accident"],
  "Dress Blouse And Skirt Manufacturers": ["Include buildings"],
  "Dress maker": ["Include stock online", "Legal expenses"],
  Drilling: ["Personal accident", "Legal expenses"],
  "Drive, path & patio laying": ["Personal accident", "Excess sum insured"],
  "Driver - heavy goods vehicle": ["Personal accident", "Legal expenses"],
  "Driver - private car": ["Personal accident", "Legal expenses"],
  "Driver - van & minibus": ["Excess sum insured", "Personal accident"],
  "Driving instructor - cars and goods vehicles under 7.5 tonne": [
    "Personal accident",
    "Legal expenses"
  ],
  "Driving instructor - other vehicles": [
    "Legal expenses",
    "Personal accident"
  ],
  "Dry Cleaners": ["Include contents", "Include stock online"],
  "Dry lining": ["Personal accident", "Legal expenses"],
  "Dry stone walling": ["Legal expenses", "Excess sum insured"],
  "Ductwork installers": ["Personal accident", "Include tools"],
  "Dvd Rental Shop": ["Include contents", "Include stock online"],
  "E-commerce": ["Include stock online", "Business interruption"],
  "Education consultant": ["Legal expenses", "Personal accident"],
  "Educational establishments - excl local authority": [
    "Legal expenses",
    "Include contents"
  ],
  "Electric Motor Wholesalers": ["Include stock online"],
  "Electric Motor, Dynamo and Generator Wholesalers": [
    "Legal expenses",
    "Include stock online"
  ],
  "Electrical Appliance Manufacturing": ["Include stock online"],
  "Electrical Goods Commercial Wholesaling": ["Include stock online"],
  "Electrical Goods Domestic Wholesaling": ["Include stock online"],
  "Electrical Goods Shop": ["Include stock online", "Include contents"],
  "Electrical Repair Shop": ["Include contents", "Include stock online"],
  "Electrical Supplies Manufacturing": ["Include buildings"],
  "Electrical goods manufacture in Industrial units": ["Include contents"],
  Electrician: ["Legal expenses", "Personal accident"],
  "Electrician - portable appliance testing": [
    "Include tools",
    "Excess sum insured"
  ],
  "Electrician in Industrial units": ["Excess sum insured", "Include contents"],
  "Electricians - commercial": ["Legal expenses", "Excess sum insured"],
  "Electricians - domestic": ["Personal accident", "Include tools"],
  "Electronic Office Machinery Wholesaling": [
    "Legal expenses",
    "Personal accident"
  ],
  "Electronic Systems Manufacturers": ["Include stock online"],
  Embroiderer: ["Include contents", "Include stock online"],
  "Employment agency": ["Legal expenses", "Excess sum insured"],
  "Energy assessment - commercial": ["Legal expenses", "Include contents"],
  "Energy assessment - domestic": ["Legal expenses", "Personal accident"],
  "Energy performance certificates / testing": [
    "Legal expenses",
    "Include contents"
  ],
  "Engineer - acoustic": ["Excess sum insured", "Personal accident"],
  "Engineers - building services": ["Personal accident", "Legal expenses"],
  "Engineers - civil": ["Personal accident", "Legal expenses"],
  "Engineers - electrical": ["Personal accident", "Legal expenses"],
  "Engineers - heating, ventilation & air-conditioning design": [
    "Legal expenses",
    "Excess sum insured"
  ],
  "Engineers - lighting": ["Excess sum insured", "Personal accident"],
  "Engineers - manufacturing (precision)": [
    "Personal accident",
    "Legal expenses"
  ],
  "Engineers - mechanical & electrical building services": [
    "Legal expenses",
    "Personal accident"
  ],
  "Engineers - mechanical (process control & production line)": [
    "Personal accident",
    "Legal expenses"
  ],
  "Engineers - project coordination (excluding appointment of subcontractors)": ["Legal expenses", "Excess sum insured"],
  "Engineers - project management": ["Legal expenses", "Personal accident"],
  "Engineers - refrigeration": ["Legal expenses", "Excess sum insured"],
  "Engineers - structural": ["Legal expenses", "Excess sum insured"],
  Engraver: ["Legal expenses", "Personal accident"],
  "Engraving / Shoe Repairing": ["Include contents", "Personal accident"],
  "Engraving Shop": ["Include contents", "Include stock online"],
  "Entertainment Supplies": ["Include contents", "Legal expenses"],
  "Entire building with multiple flats - converted building or house": [
    "Include contents",
    "Excess sum insured"
  ],
  "Entire building with multiple flats - purpose built": [
    "Include contents",
    "Excess sum insured"
  ],
  "Environmental health officers": ["Legal expenses", "Personal accident"],
  "Estate Agents in Shops & retail": ["Excess sum insured", "Include contents"],
  "Estate agent - commercial": ["Legal expenses", "Excess sum insured"],
  "Estate agent - domestic": ["Legal expenses", "Excess sum insured"],
  "Event decorator": ["Include stock online", "Legal expenses"],
  "Event organiser": ["Legal expenses", "Personal accident"],
  "Exhibition designer": ["Legal expenses", "Personal accident"],
  "Exhibition stand erector": ["Personal accident", "Include tools"],
  "Fabric Manufacturing": ["Include stock online"],
  "Fabric Shop": ["Include stock online", "Include contents"],
  Fabrications: ["Include stock online", "Legal expenses"],
  "Fabrics, Cloth & Goods in Shops & retail": [
    "Excess sum insured",
    "Include contents"
  ],
  "Face painting": ["Legal expenses", "Include tools"],
  "Facilities management": ["Legal expenses", "Personal accident"],
  "Fancy Dress Shop": ["Legal expenses", "Include stock online"],
  "Farm Shop": ["Legal expenses", "Include stock online"],
  "Fascia / guttering installation": [
    "Personal accident",
    "Excess sum insured"
  ],
  "Fashion Accessories": ["Include stock online", "Legal expenses"],
  "Fashion Accessories Shop": ["Include stock online", "Business interruption"],
  "Fashion Boutique": ["Include stock online", "Include contents"],
  "Fashion Shop": ["Include stock online", "Include contents"],
  "Fashion design": ["Include contents", "Include stock online"],
  "Fast Food": ["Include contents", "Include stock online"],
  "Fast Food / Take Away Food": ["Include contents", "Include stock online"],
  "Fast Food Shop": ["Include contents", "Include stock online"],
  "Fast food delivery": ["Legal expenses", "Excess sum insured"],
  "Fast food in Food & drink": ["Excess sum insured"],
  "Father Christmas": ["Personal accident"],
  "Fencing Manufacturing": ["Include buildings"],
  "Fencing contractors": ["Personal accident", "Legal expenses"],
  "Financial advisor / ifa": ["Legal expenses", "Include contents"],
  "Fire proofing engineer": ["Personal accident", "Legal expenses"],
  "Fireplace Shop": ["Include stock online", "Include contents"],
  "Fireplace Surround Manufacturing Stone": ["Include stock online"],
  "Fireplace installation": ["Personal accident", "Excess sum insured"],
  "First aid training": ["Legal expenses", "Include contents"],
  "Fish & Chip Shop": ["Include contents", "Business interruption"],
  "Fish & Chip Shop / Take Away Food": [
    "Include contents",
    "Include stock online"
  ],
  "Fishing Equipment (Ex Clothing) Manufacturers": [
    "Personal accident",
    "Include stock online"
  ],
  "Fishing Tackle Shop": ["Include stock online", "Include contents"],
  Fishmonger: ["Personal accident", "Include stock online"],
  "Fitness instructor": ["Legal expenses", "Personal accident"],
  "Fitted furniture installers excluding manufacturing": [
    "Excess sum insured",
    "Personal accident"
  ],
  "Fitted furniture installers including manufacturing": [
    "Legal expenses",
    "Personal accident"
  ],
  "Flooring Shop": ["Include contents", "Include stock online"],
  "Flooring Shop in Shops & retail": ["Include contents"],
  "Flooring contractors - commercial": ["Personal accident", "Legal expenses"],
  "Flooring contractors - domestic": ["Personal accident", "Legal expenses"],
  Florist: ["Include stock online", "Personal accident"],
  "Florist in Warehousing": ["Include contents"],
  "Florists / Gift Shop": ["Include stock online", "Include contents"],
  "Flower Arranging": ["Include contents", "Include stock online"],
  "Flower arranger": ["Include stock online", "Personal accident"],
  "Food Shop": ["Include contents", "Include stock online"],
  "Food stall": ["Legal expenses", "Excess sum insured"],
  "Footwear Shop": ["Include contents", "Include stock online"],
  "Fortune teller": ["Personal accident", "Hospital cash plan"],
  "French polisher": ["Personal accident", "Legal expenses"],
  "Frozen Food Shop": ["Personal accident", "Include contents"],
  "Frozen Foods Manufacturers": ["Personal accident", "Include stock online"],
  "Frozen Foods Wholesalers": ["Include stock online", "Personal accident"],
  "Fruit & Vegetable Product Wholesaling": [
    "Include stock online",
    "Include buildings"
  ],
  "Fruit And Vegetable Wholesalers": ["Include stock online", "Legal expenses"],
  "Fruit Shop": ["Include contents", "Legal expenses"],
  "Funeral Director": ["Legal expenses", "Include contents"],
  Furnisher: ["Legal expenses", "Excess sum insured"],
  "Furniture (Metal) Wholesalers": ["Legal expenses", "Include buildings"],
  "Furniture Accessories Shop": ["Legal expenses", "Include stock online"],
  "Furniture Manufacturing Wood, Bamboo or Cane": [
    "Include stock online",
    "Legal expenses"
  ],
  "Furniture Repair Shop": ["Include contents"],
  "Furniture Shop": ["Include stock online", "Include contents"],
  "Furniture in Shops & retail": ["Excess sum insured", "Include contents"],
  "Furniture removal": ["Excess sum insured", "Legal expenses"],
  "GP in Surgery": ["Excess sum insured", "Include contents"],
  "Gadget Shop": ["Legal expenses"],
  Gallery: ["Include contents", "Include stock online"],
  "Games Shop": ["Include stock online", "Include contents"],
  "Garage & shed erectors": ["Personal accident", "Include tools"],
  "Garage door and gate fitters": ["Personal accident", "Legal expenses"],
  "Garden Centre": ["Business interruption", "Include contents"],
  "Garden Equipment": ["Legal expenses", "Include contents"],
  "Garden Equipment in Shops & retail": ["Excess sum insured"],
  "Garden Shop": ["Include stock online", "Legal expenses"],
  "Garden designer": ["Legal expenses", "Personal accident"],
  "Garden machinery sale, maintenance & repair": [
    "Legal expenses",
    "Personal accident"
  ],
  "Garden maint ex tree felling": ["Personal accident", "Include tools"],
  "Garden maint inc treefelling": ["Include tools", "Personal accident"],
  "Gardening Nursery": ["Personal accident", "Include stock online"],
  "Gardening Nursery in Shops & retail": ["Excess sum insured"],
  "Gas fitters": ["Personal accident", "Excess sum insured"],
  "General Goods Store": ["Include stock online", "Include contents"],
  "General Store": ["Include contents", "Include stock online"],
  "General Store / Off Licence": ["Include stock online", "Include contents"],
  "Gift Shop": ["Include stock online", "Include contents"],
  "Gift Shop / Tea Room": ["Include contents", "Include stock online"],
  "Gift Shop / Tea Room in Shops & retail": [
    "Excess sum insured",
    "Include contents"
  ],
  "Glass Merchant": ["Legal expenses", "Include stock online"],
  "Glass Products in Shops & retail": ["Excess sum insured"],
  "Glass Works": ["Include buildings"],
  Glaziers: ["Personal accident", "Legal expenses"],
  "Glaziers inc double glazing": ["Personal accident", "Legal expenses"],
  "Golf Equipment Shop": ["Include contents", "Excess sum insured"],
  "Golf Professionals": ["Include contents", "Legal expenses"],
  "Golf Shop": ["Include contents", "Personal accident"],
  "Gourmet Food Shop": ["Include stock online"],
  "Graphic designers": ["Include contents", "Legal expenses"],
  Greengrocer: ["Include stock online", "Include contents"],
  "Greengrocer in Shops & retail": ["Include contents", "Excess sum insured"],
  "Greeting Cards": ["Include stock online", "Include contents"],
  Grocer: ["Include stock online", "Include contents"],
  "Grocer in Shops & retail": ["Include contents", "Excess sum insured"],
  "Grocery Wholesalers": ["Include stock online", "Legal expenses"],
  Groundwork: ["Personal accident", "Legal expenses"],
  "Guest House - Unlicensed": ["Personal accident", "Include contents"],
  "Gutter & fascia cleaning": ["Personal accident", "Legal expenses"],
  "Guttering, fascia installation": ["Personal accident", "Legal expenses"],
  Gymnasia: ["Include contents", "Legal expenses"],
  Haberdashery: ["Include stock online", "Include contents"],
  "Hair extension technician": ["Legal expenses", "Excess sum insured"],
  Hairdresser: ["Personal accident", "Include tools"],
  Hairdressers: ["Include contents", "Include stock online"],
  "Hairdressing & beauty salon in Shops & retail": [
    "Excess sum insured",
    "Include contents"
  ],
  "Hairdressing Salon": ["Include contents", "Include stock online"],
  "Hairpiece & Wig Shop": ["Include contents", "Business interruption"],
  "Halls and public venues - excl sports stadia": [
    "Legal expenses",
    "Excess sum insured"
  ],
  "Handmade crafts": ["Include stock online", "Legal expenses"],
  "Handyman (property maintenance only)": [
    "Personal accident",
    "Legal expenses"
  ],
  "Hardware Tools Shop": ["Include contents", "Include stock online"],
  "Hat Hire Shop": ["Include stock online", "Include contents"],
  Haulier: ["Excess sum insured", "Personal accident"],
  "Health & Beauty Shop": ["Include contents", "Include stock online"],
  "Health Food Shop": ["Include stock online", "Include contents"],
  "Health Food Shop in Shops & retail": [
    "Excess sum insured",
    "Include contents"
  ],
  "Healthcare assistant": ["Personal accident", "Legal expenses"],
  "Heavy Machinery Manufacturing": ["Legal expenses", "Include stock online"],
  "Herbs & Spices Shop": ["Legal expenses", "Include stock online"],
  "Hobby Shop": ["Include stock online", "Include contents"],
  "Home baking": ["Legal expenses", "Excess sum insured"],
  "Home help": ["Personal accident", "Legal expenses"],
  Homeopath: ["Legal expenses", "Personal accident"],
  Homewares: ["Include stock online", "Include contents"],
  "Horse Supply Shop": ["Legal expenses", "Personal accident"],
  "Horticultural Goods Shop": ["Include contents", "Include stock online"],
  "Hospitality worker": ["Legal expenses", "Personal accident"],
  "House sitters": ["Personal accident", "Legal expenses"],
  "Household Shop": ["Include contents", "Include stock online"],
  "Hygiene and cleansing services - exc industrial cleaning": [
    "Excess sum insured",
    "Legal expenses"
  ],
  "IT Consultant": ["Legal expenses", "Excess sum insured"],
  "IT Contractor": ["Legal expenses", "Excess sum insured"],
  "IT Hardware Design": ["Portable equipment", "Include contents"],
  "IT Hardware Leasing": ["Legal expenses", "Excess sum insured"],
  "IT Hardware Maintenance & Repair": ["Personal accident"],
  "IT Hardware Manufacture &/or Assembly": [
    "Include contents",
    "Portable equipment"
  ],
  "IT Hardware Sales & Supply - New": [
    "Include contents",
    "Portable equipment"
  ],
  "IT Hardware Sales & Supply - Second Hand": [
    "Legal expenses",
    "Excess sum insured"
  ],
  "IT Outsourcing - Consultancy": ["Legal expenses", "Excess sum insured"],
  "IT Outsourcing - Data Backup & Storage": [
    "Legal expenses",
    "Personal accident"
  ],
  "IT Outsourcing - Database Management": ["Legal expenses"],
  "IT Outsourcing - IT Facilities Management": [
    "Legal expenses",
    "Excess sum insured"
  ],
  "IT Programme Management": ["Legal expenses", "Excess sum insured"],
  "IT Security - Consultancy": ["Legal expenses", "Excess sum insured"],
  "IT Security - Penetration Testing": ["Legal expenses", "Excess sum insured"],
  "IT Training": ["Legal expenses", "Portable equipment"],
  "Ice Cream Parlour": ["Include contents", "Include stock online"],
  "Ice Cream Wholesalers": ["Include stock online"],
  "Ice cream van": ["Include stock online", "Legal expenses"],
  Illustrator: ["Include contents", "Legal expenses"],
  "Individual flat - in converted building or house": [
    "Include contents",
    "Legal expenses"
  ],
  "Individual flat - in purpose built block or building": [
    "Include contents",
    "Legal expenses"
  ],
  "Industrial machinery manufacture in Industrial units": ["Include contents"],
  "Injection Moulding Wholesaling Plastic": ["Include stock online"],
  "Insulation contractor": ["Personal accident", "Excess sum insured"],
  "Insurance agent / broker": ["Legal expenses", "Include contents"],
  "Insurance assessor": ["Legal expenses", "Excess sum insured"],
  "Insurance claims management": ["Personal accident", "Excess sum insured"],
  "Insurance motor vehicle inspector": ["Personal accident", "Legal expenses"],
  "Interim management": ["Legal expenses", "Portable equipment"],
  "Interior Design Shop": ["Include contents", "Include stock online"],
  "Interior Fitting Shop": ["Legal expenses", "Personal accident"],
  "Interior designer": ["Legal expenses", "Excess sum insured"],
  "Interiors Shop": ["Include stock online", "Include contents"],
  "Internet Caf\xE9": ["Include contents", "Legal expenses"],
  "Internet Service Provider": ["Legal expenses", "Excess sum insured"],
  "Internet Trader": ["Include stock online", "Legal expenses"],
  Interpreter: ["Legal expenses", "Excess sum insured"],
  "Inventory clerk": ["Legal expenses", "Personal accident"],
  "Ironing & cooking services - domestic only": [
    "Legal expenses",
    "Include tools"
  ],
  Ironmonger: ["Include contents", "Include stock online"],
  "Ironmongery & hardware in Shops & retail": ["Include contents"],
  "Jet washing": ["Personal accident", "Excess sum insured"],
  Jeweller: ["Include stock online", "Include contents"],
  Jewellers: ["Legal expenses", "Include contents"],
  "Jewellers design": ["Include stock online", "Legal expenses"],
  "Jewellery - Wholesale": ["Include stock online", "Business interruption"],
  "Jewellery Repair Shop": ["Include stock online", "Personal accident"],
  "Jewellery in Shops & retail": ["Include contents"],
  Joiners: ["Personal accident", "Include tools"],
  "Joinery Manufacturers": ["Legal expenses", "Personal accident"],
  Journalists: ["Include contents", "Personal accident"],
  "Juice Bar": ["Include contents", "Legal expenses"],
  "Key Cutters / Shoe Repairing": ["Include contents", "Personal accident"],
  "Kitchen / Bathroom Showroom": ["Include contents", "Legal expenses"],
  "Kitchen fitter": ["Legal expenses", "Personal accident"],
  "Knitted garment maker": ["Include contents", "Legal expenses"],
  "Knitwear Shop": ["Include stock online", "Excess sum insured"],
  Labourer: ["Personal accident", "Legal expenses"],
  "Lamp Shop": ["Include stock online", "Include contents"],
  "Landscape gard excluding treefelling": [
    "Personal accident",
    "Legal expenses"
  ],
  "Landscape gard including treefelling": [
    "Personal accident",
    "Legal expenses"
  ],
  "Launderette - Attended": ["Include contents", "Include stock online"],
  "Laundrette (attended) in Shops & retail": [
    "Include contents",
    "Excess sum insured"
  ],
  Lawyer: ["Include contents", "Legal expenses"],
  "Licenced Premises": ["Include contents", "Business interruption"],
  "Licensed Caf\xE9": ["Include contents", "Include stock online"],
  "Licensed grocer in Shops & retail": [
    "Include contents",
    "Excess sum insured"
  ],
  "Licensed premises in Food & drink": ["Excess sum insured"],
  "Life coach": ["Legal expenses", "Include contents"],
  "Lift engineer (incl certification)": ["Legal expenses", "Personal accident"],
  "Lift installation": ["Personal accident", "Excess sum insured"],
  "Lift maintenance": ["Personal accident", "Legal expenses"],
  "Light metal fabrication": ["Legal expenses", "Personal accident"],
  "Lighting Goods Manufacturing": ["Legal expenses"],
  "Lighting Shop": ["Include contents", "Include stock online"],
  "Linen Hire Shop": ["Personal accident", "Include contents"],
  "Lingerie Shop": ["Legal expenses", "Business interruption"],
  "Lock/Key Wholesalers": ["Personal accident", "Include buildings"],
  Locksmith: ["Include tools", "Legal expenses"],
  "Locum - general practitioner": ["Excess sum insured", "Include contents"],
  "Loss adjuster": ["Personal accident", "Excess sum insured"],
  "Loss assessor": ["Legal expenses", "Excess sum insured"],
  "Luggage & Handbag Shop": ["Excess sum insured", "Legal expenses"],
  "Machinery commissioning, repair and service": [
    "Legal expenses",
    "Personal accident"
  ],
  "Machinery installation & removal (work away) excl heat": [
    "Personal accident",
    "Legal expenses"
  ],
  Maisonette: ["Legal expenses", "Include contents"],
  "Make-up artist": ["Include tools", "Include stock online"],
  "Management consultant": ["Legal expenses", "Excess sum insured"],
  "Manicurist & pedicurist": ["Include tools", "Personal accident"],
  "Marble, Stone And Granite Wholesalers": ["Legal expenses"],
  "Marine Shop": ["Personal accident", "Illness and injury protection"],
  "Market researcher": ["Legal expenses", "Include contents"],
  "Market trader": ["Include stock online", "Legal expenses"],
  "Marketing agency": ["Legal expenses", "Include contents"],
  "Marketing consultant": ["Legal expenses", "Include contents"],
  "Marketing-direct": ["Legal expenses", "Include contents"],
  "Marquee hirer": ["Include stock online", "Legal expenses"],
  "Masonry & stone cleaning": ["Personal accident", "Legal expenses"],
  Massage: ["Legal expenses", "Personal accident"],
  "Mattress Shop": ["Include stock online"],
  "Meat, Fish & Poultry Shop": ["Include stock online", "Personal accident"],
  "Media Shop": ["Legal expenses", "Excess sum insured"],
  "Medical Equipment Manufacturers": ["Include stock online"],
  "Medical Equipment Wholesaling": ["Include stock online", "Legal expenses"],
  "Metal polishing": ["Legal expenses", "Hospital cash plan"],
  "Metalworker - Fabrication": ["Personal accident", "Include stock online"],
  "Metalworker - heavy metal goods manufacture": [
    "Personal accident",
    "Legal expenses"
  ],
  "Metalworker - high tech products": ["Hospital cash plan", "Legal expenses"],
  "Metalworker - light metal goods (incl gates and railings)": [
    "Personal accident",
    "Legal expenses"
  ],
  Milkman: ["Legal expenses", "Personal accident"],
  Millinery: ["Legal expenses", "Include stock online"],
  "Mobile Phone Shop": ["Include stock online", "Include contents"],
  "Mobile Phone Shop in Shops & retail": [
    "Include contents",
    "Excess sum insured"
  ],
  "Mobile barber (including renting a chair)": [
    "Legal expenses",
    "Include tools"
  ],
  "Mobile beautician (including renting a chair)": [
    "Legal expenses",
    "Include tools"
  ],
  "Mobile food van": ["Excess sum insured", "Personal accident"],
  "Mobile hairdresser (including renting a chair)": [
    "Include tools",
    "Personal accident"
  ],
  "Mobility Shop": ["Legal expenses", "Include stock online"],
  "Model Shop": ["Include contents", "Include stock online"],
  "Model maker": ["Personal accident", "Legal expenses"],
  "Models, model agencies": ["Legal expenses", "Include contents"],
  "Money Exchange": ["Hospital cash plan", "Include contents"],
  "Monumental mason & sculptures": ["Include contents", "Excess sum insured"],
  "Mortgage adviser / broker": ["Legal expenses", "Include contents"],
  "Motor trade & garage in Shops & retail": [
    "Include contents",
    "Excess sum insured"
  ],
  "Motorbike Accessories": ["Include stock online", "Include contents"],
  "Music Shop": ["Include contents", "Include stock online"],
  "Music teacher / publisher": ["Legal expenses", "Include contents"],
  "Musical Instrument Shop": ["Include stock online"],
  "Musician - group - classical, folk & group": [
    "Legal expenses",
    "Excess sum insured"
  ],
  "Musician - group - other": ["Include contents", "Legal expenses"],
  "Musician - individual - classical, folk or jazz": [
    "Legal expenses",
    "Excess sum insured"
  ],
  "Musician - individual - other": ["Include contents", "Legal expenses"],
  "Mustard Spice And Pepper Wholesalers": ["Include stock online"],
  "Nail Bar": ["Include contents", "Legal expenses"],
  "Nail Bar in Shops & retail": ["Excess sum insured", "Include contents"],
  Nanny: ["Personal accident", "Legal expenses"],
  "Network & Systems Support": ["Legal expenses", "Excess sum insured"],
  "News Stand": ["Include stock online"],
  Newsagents: ["Include stock online", "Include contents"],
  "Newsagents / Off Licence": ["Include stock online", "Include contents"],
  "Newsagents / Post Office": ["Include stock online", "Include contents"],
  "Newsagents in Shops & retail": ["Excess sum insured", "Include contents"],
  "Non-dispensing Chemist": ["Legal expenses", "Include contents"],
  Nurse: ["Legal expenses", "Personal accident"],
  "Nursery schools and playgroups": ["Legal expenses", "Personal accident"],
  Nutritionist: ["Legal expenses", "Excess sum insured"],
  "Nvq assessor": ["Legal expenses", "Personal accident"],
  "Occupational therapist": ["Legal expenses", "Excess sum insured"],
  "Off Licence": ["Include stock online", "Include contents"],
  "Off-licence in Shops & retail": ["Excess sum insured", "Include contents"],
  "Office Equipment Supplier (Including Electrical)": [
    "Legal expenses",
    "Include stock online"
  ],
  "Office Furniture Shop": ["Include stock online", "Personal accident"],
  "Office Services Shop": ["Legal expenses"],
  "Office Supplies Shop": ["Include contents", "Personal accident"],
  "Office cleaner": ["Personal accident", "Legal expenses"],
  "Office equipment repair": ["Personal accident"],
  "Offices & clerical services in Offices": [
    "Include contents",
    "Excess sum insured"
  ],
  "Ofsted inspector": ["Legal expenses"],
  "Online Retailer": ["Include stock online", "Legal expenses"],
  "Online Shop": ["Include stock online", "Legal expenses"],
  "Online Store": ["Legal expenses", "Include stock online"],
  Optician: ["Include contents", "Include stock online"],
  "Opticians in Shops & retail": ["Include contents", "Excess sum insured"],
  Optometrist: ["Legal expenses", "Include contents"],
  "Organic Food Shop": ["Include contents", "Legal expenses"],
  Other: ["Include contents", "Excess sum insured"],
  "Paint & Wallpaper Shop": ["Excess sum insured", "Include stock online"],
  "Paint sprayers": ["Personal accident", "Legal expenses"],
  "Painter & decorator": ["Personal accident", "Legal expenses"],
  "Painter (artistic, sculptors or potters)": [
    "Personal accident",
    "Legal expenses"
  ],
  "Partition contractor": ["Include tools", "Excess sum insured"],
  "Party planner": ["Legal expenses", "Personal accident"],
  "Path, patio & drive laying": ["Personal accident", "Excess sum insured"],
  Pathologist: ["Excess sum insured", "Legal expenses"],
  "Pedicurist & manicurist": ["Legal expenses", "Personal accident"],
  "Pen Shop": ["Legal expenses"],
  "Perfume Shop": ["Include stock online", "Legal expenses"],
  "Personal / sports trainer": ["Personal accident", "Legal expenses"],
  "Personal Training Shop": ["Include contents", "Legal expenses"],
  "Personal assistant": ["Personal accident", "Legal expenses"],
  "Pest & vermin control services": ["Personal accident", "Legal expenses"],
  "Pet Accessory Shop": ["Include stock online", "Include contents"],
  "Pet Beautician in Shops & retail": ["Include contents"],
  "Pet Parlour": ["Include stock online", "Personal accident"],
  "Pet Shop": ["Include stock online", "Include contents"],
  "Pet Shop in Shops & retail": ["Excess sum insured"],
  "Pet grooming": ["Personal accident", "Legal expenses"],
  "Pet minder": ["Personal accident", "Legal expenses"],
  "Pharmaceutical Supplier": ["Personal accident", "Legal expenses"],
  Pharmacy: ["Include contents", "Personal accident"],
  "Pharmacy in Shops & retail": ["Include contents", "Excess sum insured"],
  "Photo Processing & Printing Shop": [
    "Include contents",
    "Include stock online"
  ],
  Photobooth: ["Include contents", "Portable equipment"],
  Photographer: ["Include contents", "Portable equipment"],
  "Photographic Studio": ["Include contents", "Legal expenses"],
  Physiologist: ["Legal expenses", "Personal accident"],
  Physiotherapist: ["Legal expenses", "Personal accident"],
  "Piano tuner": ["Include tools", "Personal accident"],
  "Pickled Food Wholesalers": ["Personal accident", "Include stock online"],
  "Picture Framing": ["Include stock online", "Include contents"],
  "Picture Shop": ["Include stock online"],
  "Picture framer": ["Legal expenses", "Include stock online"],
  "Pipe & Tube Manufacturing Plastic": ["Include stock online"],
  "Pipework contractors - commercial": [
    "Personal accident",
    "Excess sum insured"
  ],
  "Plant hire - commercial": ["Legal expenses", "Excess sum insured"],
  "Plant hire - diy": ["Include contents", "Legal expenses"],
  "Plant user - construction plant exc cranes": [
    "Personal accident",
    "Legal expenses"
  ],
  Plasterer: ["Personal accident", "Legal expenses"],
  "Playgroups and nursery schools": ["Legal expenses", "Personal accident"],
  "Plumbers Merchant": ["Personal accident", "Include contents"],
  "Plumbing, heating and ventilation contractor": [
    "Legal expenses",
    "Personal accident"
  ],
  "Pneumatic Equipment Manufacturers": ["Legal expenses"],
  "Portable appliance testing": ["Excess sum insured", "Legal expenses"],
  "Post Office": ["Include stock online", "Include contents"],
  "Post Office Services": ["Include stock online", "Include contents"],
  "Pottery Goods Manufacturers": ["Include stock online"],
  "Pottery Shop": ["Include stock online", "Include contents"],
  Preacher: ["Legal expenses", "Excess sum insured"],
  "Precision Engineers": ["Legal expenses", "Include stock online"],
  "Precision engineer in Industrial units": ["Include contents"],
  "Pressure washing": ["Excess sum insured", "Personal accident"],
  "Principal contractor": ["Legal expenses", "Excess sum insured"],
  "Principal designer": ["Legal expenses", "Excess sum insured"],
  "Print Shop": ["Include contents", "Include stock online"],
  Printers: ["Legal expenses", "Include stock online"],
  "Printing - computer based": ["Include stock online", "Include contents"],
  "Printing - other": ["Personal accident", "Legal expenses"],
  "Private investigator": ["Legal expenses", "Excess sum insured"],
  "Probate services": ["Excess sum insured", "Legal expenses"],
  "Product design": ["Legal expenses", "Personal accident"],
  "Project manager": ["Legal expenses", "Personal accident"],
  "Property auditor": ["Legal expenses", "Excess sum insured"],
  "Property maintenance / handyman": ["Excess sum insured", "Legal expenses"],
  "Property managing agent - commercial": [
    "Legal expenses",
    "Excess sum insured"
  ],
  "Property managing agent - residential": [
    "Legal expenses",
    "Excess sum insured"
  ],
  "Property searches": ["Legal expenses", "Excess sum insured"],
  Psychiatrist: ["Excess sum insured", "Legal expenses"],
  Psychologist: ["Legal expenses", "Include contents"],
  Psychotherapist: ["Legal expenses", "Include contents"],
  "Public House": ["Include contents", "Include stock online"],
  "Public Houses / Restaurant - Licensed": [
    "Include contents",
    "Include stock online"
  ],
  "Public relations officer": ["Legal expenses", "Personal accident"],
  "Publicity management": ["Legal expenses", "Include contents"],
  Publisher: ["Legal expenses", "Excess sum insured"],
  "Record Shop": ["Include stock online", "Include contents"],
  "Recruitment agency": ["Legal expenses", "Excess sum insured"],
  "Recruitment consultant": ["Legal expenses", "Include contents"],
  Reflexologist: ["Personal accident", "Include stock online"],
  "Refrigeration Engineering": ["Legal expenses"],
  "Refrigeration engineers": ["Personal accident", "Legal expenses"],
  Rendering: ["Legal expenses", "Personal accident"],
  "Residents association": ["Legal expenses"],
  "Residents association (Not For Profit)": ["Legal expenses"],
  "Restaurant - Licensed": ["Include contents", "Include stock online"],
  "Restaurant - Unlicensed": ["Include contents", "Include stock online"],
  "Restaurant - licensed in Food & drink": [
    "Excess sum insured",
    "Include contents"
  ],
  "Restaurant - unlicensed in Food & drink": ["Excess sum insured"],
  "Road marking contractors": ["Legal expenses", "Personal accident"],
  "Roofers excluding the application of heat": [
    "Personal accident",
    "Legal expenses"
  ],
  "Roofers including the application of heat": [
    "Personal accident",
    "Excess sum insured"
  ],
  "Saddlery & Tack Shop": ["Legal expenses", "Include stock online"],
  "Safety Workwear Shop": ["Include contents", "Excess sum insured"],
  "Sales representative": ["Personal accident", "Legal expenses"],
  "Sandwich Bar": ["Include contents", "Business interruption"],
  "Sandwich Bar / Take Away Food": ["Include contents", "Include stock online"],
  "Sandwich bar in Food & drink": ["Excess sum insured"],
  "Santa Claus": ["Personal accident", "Excess sum insured"],
  "Satellite dish installer": ["Personal accident", "Excess sum insured"],
  "Sauce And Pickle Manufacturing": ["Legal expenses"],
  Scaffolding: ["Excess sum insured", "Personal accident"],
  "School Uniform Shop": ["Include contents", "Include stock online"],
  "Schools and colleges": ["Personal accident", "Legal expenses"],
  "Screen / script writer": ["Include contents", "Legal expenses"],
  "Sculpture Shop": ["Include contents", "Include stock online"],
  "Seasonal Dress Shop": ["Include stock online", "Include contents"],
  "Second Hand Furniture Shop": ["Include stock online", "Include contents"],
  "Secretarial / clerical services": ["Legal expenses", "Include contents"],
  "Security - training only": ["Legal expenses", "Excess sum insured"],
  "Security Goods Shop": ["Legal expenses", "Personal accident"],
  "Security Systems Shop": ["Include contents", "Legal expenses"],
  "Security guard": ["Legal expenses", "Excess sum insured"],
  "Semi-detached house": ["Legal expenses", "Include contents"],
  "Server Hosting": ["Legal expenses", "Include contents"],
  "Sewing Machine Shop": ["Include contents", "Include stock online"],
  "Sewing Supplies": ["Include contents", "Business interruption"],
  "Sewing/Textile Machine Manufacturers": ["Include stock online"],
  "Sharpening Services": ["Include stock online"],
  "Shed & carport erector": ["Excess sum insured", "Legal expenses"],
  "Shoe Repair Shop": ["Include stock online", "Include contents"],
  "Shoe Shop": ["Include contents", "Include stock online"],
  "Shoe polisher": ["Personal accident"],
  "Shoe repairer": ["Include stock online", "Include contents"],
  "Shop fitters": ["Personal accident", "Excess sum insured"],
  Shuttering: ["Legal expenses", "Excess sum insured"],
  "Sign Making - Plastic": ["Legal expenses", "Include stock online"],
  "Sign Manufacturing Metal Illuminated": [
    "Personal accident",
    "Include buildings"
  ],
  "Sign erectors": ["Personal accident", "Legal expenses"],
  "Sign writer in Shops & retail": ["Excess sum insured"],
  Signwriter: ["Personal accident", "Legal expenses"],
  Singer: ["Include contents", "Personal accident"],
  "Site clearance": ["Excess sum insured", "Personal accident"],
  "Skip hire": ["Legal expenses", "Include own plant"],
  "Snack Bar": ["Include contents", "Business interruption"],
  "Social worker": ["Legal expenses", "Personal accident"],
  "Soft Drinks Manufacturing": ["Legal expenses", "Include stock online"],
  "Soft Drinks Wholesalers": ["Legal expenses", "Include stock online"],
  "Soft Furnishings Shop": ["Include contents", "Legal expenses"],
  "Software Consultant": ["Legal expenses", "Excess sum insured"],
  "Software Developer": ["Legal expenses", "Excess sum insured"],
  "Software Engineer": ["Legal expenses", "Portable equipment"],
  "Software house & video game production in Offices": ["Excess sum insured"],
  "Solar panel installation": ["Legal expenses", "Personal accident"],
  Solicitor: ["Legal expenses", "Include contents"],
  "Speech therapist": ["Legal expenses", "Include contents"],
  "Sports Equipment (excl. Clothing) in Warehousing": ["Excess sum insured"],
  "Sports Goods Shop": ["Include stock online", "Include contents"],
  "Sports Shop": ["Include stock online", "Include contents"],
  "Sports/personal trainer": ["Legal expenses", "Personal accident"],
  "Sportswear Shop": ["Legal expenses", "Include stock online"],
  "Staircase (Wood) Manufacturers": ["Legal expenses", "Include stock online"],
  "Standalone Tools": ["Include tools"],
  "Stationary Shop": ["Include contents", "Include stock online"],
  Stationer: ["Legal expenses", "Include stock online"],
  "Stationery in Shops & retail": ["Include contents"],
  Statistician: ["Legal expenses", "Include contents"],
  "Steel erection": ["Personal accident", "Excess sum insured"],
  Stockbroker: ["Include contents"],
  Stonemason: ["Personal accident", "Legal expenses"],
  "Storage Plant And Tanks and Process Vessels - Manufacturing": [
    "Legal expenses",
    "Personal accident"
  ],
  "Stove Shop": ["Legal expenses", "Include stock online"],
  "Sunglasses Shop": ["Excess sum insured", "Legal expenses"],
  Supermarket: ["Include stock online", "Include contents"],
  "Supermarket Wholesale": ["Include stock online"],
  "Support worker": ["Personal accident", "Legal expenses"],
  "Surveyor - building society agency": ["Personal accident"],
  "Surveyor - building surveying": ["Legal expenses", "Personal accident"],
  "Surveyor - commercial": ["Legal expenses", "Excess sum insured"],
  "Surveyor - damp proof & control": ["Legal expenses", "Excess sum insured"],
  "Surveyor - expert witness": ["Legal expenses"],
  "Surveyor - land & hydrographic": ["Legal expenses", "Personal accident"],
  "Surveyor - party wall/schedules of dilapidations": [
    "Legal expenses",
    "Personal accident"
  ],
  "Surveyor - planning supervision": ["Legal expenses", "Include tools"],
  "Surveyor - project coordination": ["Excess sum insured", "Legal expenses"],
  "Surveyor - project management": ["Legal expenses", "Personal accident"],
  "Surveyor - quantity surveying": ["Legal expenses", "Excess sum insured"],
  "Surveyor - rating consultancy": ["Legal expenses", "Excess sum insured"],
  "Surveyor - residential": ["Legal expenses", "Personal accident"],
  "Sweet Shop": ["Include stock online", "Include contents"],
  "Sweet Wholesaling": ["Personal accident", "Legal expenses"],
  "Swim Shop": ["Include stock online", "Include contents"],
  "Swimming pool cleaners": ["Legal expenses", "Excess sum insured"],
  "Swimming pool installers": ["Legal expenses", "Excess sum insured"],
  Tailor: ["Include stock online", "Personal accident"],
  "Tailor And Outfitter": ["Include buildings", "Legal expenses"],
  "Take Away Food": ["Include contents", "Include stock online"],
  "Take-away food in Food & drink": ["Excess sum insured", "Include contents"],
  "Tax advisor": ["Legal expenses", "Excess sum insured"],
  "Taxi driver": ["Legal expenses", "Excess sum insured"],
  Taxidermist: ["Include stock online", "Excess sum insured"],
  "Tea & Coffee Shop": ["Include contents", "Include stock online"],
  "Tea Room": ["Include contents", "Include stock online"],
  "Teacher / tutor": ["Legal expenses", "Include contents"],
  "Teaching assistant": ["Excess sum insured", "Personal accident"],
  "Telecommunication Equipment Wholesalers": [
    "Personal accident",
    "Include stock online"
  ],
  "Telecommunications Shop": ["Include contents", "Include stock online"],
  "Telemarketer / telesales": ["Legal expenses", "Personal accident"],
  "Telephone engineers": ["Personal accident", "Legal expenses"],
  "Telephone point/extension installation": ["Legal expenses"],
  "Terraced / End terrace house": ["Legal expenses", "Include contents"],
  "Textile Manufacturing": ["Include buildings", "Include stock online"],
  "Textile Shop": ["Include stock online", "Include contents"],
  "Textile Wholesalers": ["Include stock online"],
  "Theatre and concert lighting": ["Personal accident", "Legal expenses"],
  "Theatre group": ["Excess sum insured"],
  "Ticket / theatre agent": ["Excess sum insured", "Legal expenses"],
  "Tile Shop": ["Legal expenses", "Include contents"],
  "Tile Wholesalers": ["Include stock online"],
  "Tilers - floor & wall": ["Personal accident", "Legal expenses"],
  "Tilers - roofs": ["Personal accident", "Excess sum insured"],
  "Timber preservation": ["Legal expenses", "Personal accident"],
  Tobacconist: ["Include stock online", "Business interruption"],
  "Tool Rental Shop": ["Include contents", "Business interruption"],
  "Tour guide": ["Legal expenses", "Excess sum insured"],
  "Tour operator": ["Excess sum insured", "Legal expenses"],
  "Tourism / Tour Attraction Shop": ["Legal expenses", "Include contents"],
  "Town planner": ["Legal expenses", "Include contents"],
  "Toy & Game Shop": ["Include stock online", "Include contents"],
  "Toy Wholesalers": ["Include buildings"],
  Trainer: ["Legal expenses", "Include contents"],
  Training: ["Legal expenses", "Excess sum insured"],
  Translator: ["Legal expenses", "Personal accident"],
  "Travel agency": ["Legal expenses", "Excess sum insured"],
  "Travel agent in Shops & retail": ["Include contents", "Excess sum insured"],
  "Trophies (Glass) Wholesalers": ["Personal accident", "Include stock online"],
  "Trophy Shop": ["Include stock online", "Include contents"],
  "Tv & Radio Shop": ["Business interruption", "Include contents"],
  "Tv and video installation": ["Legal expenses", "Excess sum insured"],
  "UPVC Window And Door Manufacturers And Installers": [
    "Personal accident",
    "Legal expenses"
  ],
  "Underwriting agent": ["Hospital cash plan", "Excess sum insured"],
  "Unlicensed Grocer": ["Include contents", "Include stock online"],
  "Upholstery & furniture repair": ["Legal expenses", "Personal accident"],
  "Upholstery Shop": ["Legal expenses", "Personal accident"],
  "Vacuum Cleaner Repair Shop": ["Include contents", "Include stock online"],
  "Vending machine operator": ["Legal expenses", "Include stock online"],
  "Venetian Blind Supplier": ["Personal accident", "Legal expenses"],
  "Video editor": ["Include contents", "Legal expenses"],
  "Videographer exc underwater and aerial": [
    "Include contents",
    "Legal expenses"
  ],
  "Village & community hall in Leisure trades": [
    "Include contents",
    "Excess sum insured"
  ],
  "Vintage Clothes Shop": ["Include stock online", "Include contents"],
  "Virtual assistant": ["Legal expenses", "Include contents"],
  "Warehouse/Wholesaler in Warehousing": [
    "Include contents",
    "Excess sum insured"
  ],
  "Watch & Clock Shop": ["Include contents", "Include stock online"],
  Watchmaker: ["Legal expenses", "Include stock online"],
  "Web Site Designer": ["Legal expenses", "Excess sum insured"],
  "Web marketing": ["Legal expenses", "Excess sum insured"],
  "Wedding Shop": ["Include stock online", "Include contents"],
  Welders: ["Personal accident", "Legal expenses"],
  "Well Being Shop": ["Include contents", "Include stock online"],
  "Wellbeing charity": ["Excess sum insured", "Personal accident"],
  "Wheelie bin cleaner": ["Personal accident", "Excess sum insured"],
  "Will writing": ["Legal expenses", "Excess sum insured"],
  "Window & Door Wholesaling Inc Fitting": [
    "Legal expenses",
    "Include stock online"
  ],
  "Window cleaner": ["Personal accident", "Excess sum insured"],
  "Wine And Spirit Merchant": ["Legal expenses", "Include stock online"],
  "Wine Bar": ["Include contents", "Include stock online"],
  "Wine Shop": ["Include stock online", "Include contents"],
  "Women's group": ["Legal expenses"],
  "Wooden Finished Goods Manufacturers": [
    "Legal expenses",
    "Include stock online"
  ],
  "Woodworking machinist": ["Legal expenses", "Include tools"],
  "Wool & Needlework": ["Include stock online", "Include contents"],
  "Wool Shop": ["Include stock online", "Include contents"]
};
var getCoversByTrade = (trade) => {
  if (!trade) return null;
  const selectedCovers = tradeCovers[trade];
  if (!selectedCovers) return null;
  return selectedCovers;
};

// src/utils/snowplow.ts
import { getContexts, Snowplow } from "@simplybusiness/services";
var airbrake2 = getAirbrake();
var getSnowplow = (props) => {
  const trackingProps = {
    uid: props.uid,
    //NB: This value may be null if a customer doesn't have an analysis_uid yet
    duid: props.duid,
    cookieDomain: props.cookieDomain,
    avalancheCollector: props.avalancheCollector,
    appId: props.appId,
    includeGAContext: false,
    eventMethod: "post",
    postPath: "/com.simplybusiness/events",
    trackActivity: false,
    trackPageView: false,
    forceSecureTracker: true
  };
  if (!props.duid) {
    airbrake2.notify({
      error: "A null DUID was provided when initialising Snowplow",
      params: {
        source: "mobius-interventions",
        component: "getSnowplow",
        userId: props.duid,
        site: props.site
      }
    });
  }
  const snowplow = new Snowplow(trackingProps);
  snowplow.setContexts(getContexts(trackingProps));
  return snowplow;
};
var buildInterventionEventBody = (interventionName, duid, site, action) => {
  return {
    schema: "iglu:com.simplybusiness/intervention_interaction_completed/jsonschema/2-1-0",
    data: {
      intervention_name: interventionName,
      user_unique_identifier: duid,
      user_unique_identifier_type: "duid",
      action,
      site
    }
  };
};

// src/components/CoverageDiagnosis/DynamicContent/CoverDisplay/CoverDisplay.tsx
import { useEffect } from "react";
import { circleTick, rightArrow } from "@simplybusiness/icons";
import { Button, Flex, Icon, Text } from "@simplybusiness/mobius";
import { jsx, jsxs } from "react/jsx-runtime";
var CoverDisplay = ({
  trade,
  onCTAClick,
  fireEvent
}) => {
  const tradeCovers2 = getCoversByTrade(trade);
  useEffect(() => {
    fireEvent("cd_cover_list_shown");
  }, [fireEvent]);
  return /* @__PURE__ */ jsxs(Flex, { flexDirection: "column", alignItems: "center", justifyContent: "center", children: [
    /* @__PURE__ */ jsx(
      Text,
      {
        elementType: "h4",
        className: "mobius-interventions__coverage-diagnosis-header",
        children: "Covers tailored to your business*"
      }
    ),
    /* @__PURE__ */ jsx(
      Text,
      {
        variant: "small",
        className: "mobius-interventions__coverage-diagnosis-text",
        children: "These covers are the most popular for"
      }
    ),
    /* @__PURE__ */ jsx(
      Text,
      {
        variant: "small",
        className: "mobius-interventions__coverage-diagnosis-trade-name",
        children: trade
      }
    ),
    /* @__PURE__ */ jsx(Flex, { flexDirection: "column", alignItems: "baseline", gap: 4, children: ["Public liability", ...tradeCovers2].map((cover) => /* @__PURE__ */ jsxs(Flex, { justifyContent: "center", alignItems: "center", gap: 8, children: [
      /* @__PURE__ */ jsx(Icon, { icon: circleTick, size: "sm", color: "green" }),
      /* @__PURE__ */ jsx(Text, { variant: "small", elementType: "span", children: cover })
    ] }, cover)) }),
    /* @__PURE__ */ jsxs(
      Button,
      {
        className: "mobius-interventions__coverage-diagnosis-cover-display-cta",
        size: "sm",
        onPress: onCTAClick,
        children: [
          "Close and continue\xA0\xA0",
          /* @__PURE__ */ jsx(Icon, { size: "sm", icon: rightArrow })
        ]
      }
    )
  ] });
};

// src/components/CoverageDiagnosis/DynamicContent/TradeSelection/TradeSelection.tsx
import { useRef } from "react";
import { Button as Button2, Icon as Icon2 } from "@simplybusiness/mobius";
import { TradeSelector } from "@simplybusiness/mobius-trade-selector";
import { rightArrow as rightArrow2 } from "@simplybusiness/icons";
import { Fragment, jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var TradeSelection = ({
  vertical,
  site,
  setSelectedTrade,
  setCTAPressed,
  fireEvent
}) => {
  const selectedTradeRef = useRef(false);
  return /* @__PURE__ */ jsxs2(Fragment, { children: [
    /* @__PURE__ */ jsx2("div", { className: "mobius-interventions__coverage-diagnosis-trade-selector", children: /* @__PURE__ */ jsx2(
      TradeSelector,
      {
        label: "What is your trade or profession?",
        site,
        vertical,
        variant: "default",
        onSelectTrade: (trade) => {
          selectedTradeRef.current = true;
          fireEvent("cd_trade_selected");
          setSelectedTrade(trade);
        }
      }
    ) }),
    /* @__PURE__ */ jsxs2(
      Button2,
      {
        className: "mobius-interventions__coverage-diagnosis-dynamic-content-cta",
        size: "sm",
        "data-testid": "coverage-diagnosis-see-covers",
        onPress: () => {
          if (selectedTradeRef.current) {
            fireEvent("cd_see_covers");
            setCTAPressed(true);
          }
        },
        children: [
          "See Covers\xA0\xA0",
          /* @__PURE__ */ jsx2(Icon2, { size: "sm", icon: rightArrow2 })
        ]
      }
    )
  ] });
};

// src/components/CoverageDiagnosis/DynamicContent/LetDown/LetDown.tsx
import { useEffect as useEffect2 } from "react";
import { Button as Button3, Icon as Icon3, Flex as Flex2, Text as Text2 } from "@simplybusiness/mobius";
import { rightArrow as rightArrow3 } from "@simplybusiness/icons";
import { jsx as jsx3, jsxs as jsxs3 } from "react/jsx-runtime";
var LetDown = ({ fireEvent, onCTAClick }) => {
  useEffect2(() => {
    fireEvent("cd_rejection");
  }, [fireEvent]);
  return /* @__PURE__ */ jsxs3(
    Flex2,
    {
      className: "mobius-interventions__coverage-diagnosis-letdown",
      "data-testid": "coverage-diagnosis-letdown",
      flexDirection: "column",
      alignItems: "baseline",
      justifyContent: "center",
      children: [
        /* @__PURE__ */ jsx3(Text2, { elementType: "h4", children: "We apologise but this feature is not available at this time, please click the button below to complete a full quote." }),
        /* @__PURE__ */ jsxs3(
          Button3,
          {
            className: "mobius-interventions__coverage-diagnosis-cover-display-cta",
            size: "sm",
            onPress: onCTAClick,
            children: [
              "Close and continue\xA0\xA0",
              /* @__PURE__ */ jsx3(Icon3, { size: "sm", icon: rightArrow3 })
            ]
          }
        )
      ]
    }
  );
};

// src/components/CoverageDiagnosis/DynamicContent/DynamicContent.tsx
import { Fragment as Fragment2, jsx as jsx4, jsxs as jsxs4 } from "react/jsx-runtime";
var DynamicContent = ({
  site,
  vertical,
  closeModalCallback,
  fireEvent
}) => {
  const [selectedTrade, setSelectedTrade] = useState(null);
  const [ctaPressed, setCTAPressed] = useState(false);
  const tradeCovers2 = getCoversByTrade(selectedTrade?.value);
  const pressedButInvalidTrade = ctaPressed && selectedTrade && !tradeCovers2;
  const pressedAndValidTrade = ctaPressed && selectedTrade && tradeCovers2;
  const haventPressed = !ctaPressed;
  return /* @__PURE__ */ jsxs4(Fragment2, { children: [
    /* @__PURE__ */ jsxs4(Container, { className: "mobius-interventions__coverage-diagnosis-dynamic-content", children: [
      pressedButInvalidTrade && /* @__PURE__ */ jsx4(LetDown, { fireEvent, onCTAClick: closeModalCallback }),
      pressedAndValidTrade && /* @__PURE__ */ jsx4(
        CoverDisplay,
        {
          trade: selectedTrade.value,
          onCTAClick: closeModalCallback,
          fireEvent
        }
      ),
      haventPressed && /* @__PURE__ */ jsx4(
        TradeSelection,
        {
          site,
          vertical,
          setSelectedTrade,
          setCTAPressed,
          fireEvent
        }
      )
    ] }),
    pressedAndValidTrade && /* @__PURE__ */ jsx4(
      Text3,
      {
        variant: "legal",
        className: "mobius-interventions__coverage-diagnosis-disclaimer",
        "data-testid": "coverage-diagnosis-disclaimer",
        children: "*Other cover options will be available when you complete your quote"
      }
    )
  ] });
};

// src/components/CoverageDiagnosis/CoverageDiagnosis.tsx
import { jsx as jsx5, jsxs as jsxs5 } from "react/jsx-runtime";
var CoverageDiagnosis = (props) => {
  const { vertical, initialShow, fireEvent, site } = props;
  const [isOpen, setIsOpen] = useState2(false);
  useEffect3(() => {
    if (initialShow) setIsOpen(true);
  }, [initialShow, setIsOpen]);
  if (!site || !fireEvent) return null;
  return /* @__PURE__ */ jsxs5(
    Modal,
    {
      className: "mobius-interventions__coverage-diagnosis-modal",
      isOpen,
      animation: "fade",
      onOpen: () => {
        fireEvent("cd_shown");
      },
      onClose: () => {
        fireEvent("cd_modal_closed");
        setIsOpen(false);
      },
      children: [
        /* @__PURE__ */ jsx5(
          Text4,
          {
            variant: "h2",
            className: "mobius-interventions__coverage-diagnosis-modal-primary-text",
            children: "Unsure what insurance you need?"
          }
        ),
        /* @__PURE__ */ jsx5(
          Text4,
          {
            variant: "small",
            className: "mobius-interventions__coverage-diagnosis-modal-secondary-text",
            children: "Get a list of tailored covers in seconds!"
          }
        ),
        /* @__PURE__ */ jsx5(
          DynamicContent,
          {
            site,
            vertical,
            closeModalCallback: () => {
              setIsOpen(false);
            },
            fireEvent
          }
        ),
        /* @__PURE__ */ jsx5(
          Button4,
          {
            "data-testid": "coverage-diagnosis-modal-close-button",
            className: "mobius-interventions__coverage-diagnosis-modal-button",
            variant: "ghost",
            size: "sm",
            onPress: () => {
              setIsOpen(false);
            },
            children: "Close"
          }
        ),
        /* @__PURE__ */ jsx5(
          "div",
          {
            "data-testid": "coverage-diagnosis-modal-image",
            className: "mobius-interventions__coverage-diagnosis-modal-image"
          }
        )
      ]
    }
  );
};

// src/components/DiscountVoucherIntervention/DiscountVoucherIntervention.tsx
import { useState as useState3 } from "react";
import { lightbulbOn } from "@simplybusiness/icons";
import { Icon as Icon5 } from "@simplybusiness/mobius";

// src/components/DiscountVoucherIntervention/DiscountVoucherButton.tsx
import { Button as Button5, LoadingIndicator } from "@simplybusiness/mobius";
import classNames from "classnames/dedupe";
import { jsx as jsx6 } from "react/jsx-runtime";
var DiscountVoucherButton = ({
  mobile,
  onClick,
  isPending = false
}) => {
  const buttonClassName = mobile ? `discount-voucher__button--mobile` : `discount-voucher__button--desktop`;
  return /* @__PURE__ */ jsx6(
    Button5,
    {
      onClick,
      className: classNames(
        "mobius-discount-voucher-button discount-voucher__button",
        buttonClassName
      ),
      variant: "secondary",
      size: "sm",
      "data-testid": "claim-voucher-button",
      children: isPending ? /* @__PURE__ */ jsx6(LoadingIndicator, {}) : "Claim your voucher"
    }
  );
};

// src/components/shared/StickyFooter/StickyFooter.tsx
import classNames2 from "classnames/dedupe";
import { jsx as jsx7 } from "react/jsx-runtime";
var StickyFooter = ({
  hidden = false,
  className = "",
  children
}) => {
  const classes = classNames2("sticky__footer", className, {
    "sticky__footer--hidden": hidden
  });
  return /* @__PURE__ */ jsx7("div", { className: classes, "data-testid": "sticky__footer", "aria-hidden": hidden, children: /* @__PURE__ */ jsx7("div", { className: "sticky__content", children }) });
};

// src/components/shared/StickyFooter/StickyFooterCloseButton.tsx
import classNames3 from "classnames/dedupe";
import { cross } from "@simplybusiness/icons";
import { Button as Button6, Icon as Icon4, Text as Text5 } from "@simplybusiness/mobius";
import { jsx as jsx8, jsxs as jsxs6 } from "react/jsx-runtime";
var StickyFooterCloseButton = ({
  onClose,
  className,
  testId
}) => /* @__PURE__ */ jsxs6(
  Button6,
  {
    className: classNames3("sticky-footer__close-button", className),
    size: "sm",
    onPress: onClose,
    "aria-label": "Close",
    "data-testid": testId,
    children: [
      /* @__PURE__ */ jsx8(
        Icon4,
        {
          icon: cross,
          size: "sm",
          className: "sticky-footer__close-button-icon",
          "data-testid": "sticky-footer__close-button"
        }
      ),
      /* @__PURE__ */ jsx8(Text5, { elementType: "p", className: "sticky-footer__close-button-text", children: "Close" })
    ]
  }
);

// src/components/shared/StickyFooter/StickyFooterText.tsx
import { Link, Text as Text6 } from "@simplybusiness/mobius";
import { jsx as jsx9, jsxs as jsxs7 } from "react/jsx-runtime";
var StickyFooterText = ({
  headlineText,
  descriptionText,
  disclaimerUrl
}) => /* @__PURE__ */ jsxs7("div", { children: [
  /* @__PURE__ */ jsx9(Text6, { elementType: "p", variant: "h4", className: "sticky-footer__headline", children: headlineText }),
  /* @__PURE__ */ jsx9(Text6, { elementType: "p", className: "sticky-footer__description", children: descriptionText }),
  disclaimerUrl && /* @__PURE__ */ jsx9(Link, { href: disclaimerUrl, className: "sticky-footer__disclaimer", children: "Terms and conditions" })
] });

// src/components/DiscountVoucherIntervention/DiscountVoucherIntervention.tsx
import { jsx as jsx10, jsxs as jsxs8 } from "react/jsx-runtime";
var DiscountVoucherIntervention = (props) => {
  const { code, onDismiss, onClick, isPending } = props;
  const [hidden, setHidden] = useState3(false);
  const handleClose = () => {
    setHidden(true);
    if (onDismiss) onDismiss();
  };
  return /* @__PURE__ */ jsxs8(StickyFooter, { hidden, children: [
    /* @__PURE__ */ jsxs8("div", { className: "discount-voucher__content-desktop-container", children: [
      /* @__PURE__ */ jsxs8("div", { className: "discount-voucher__text", children: [
        /* @__PURE__ */ jsx10(
          Icon5,
          {
            icon: lightbulbOn,
            size: "md",
            className: "discount-voucher__text-icon",
            "data-testid": "discount-voucher__text-icon"
          }
        ),
        /* @__PURE__ */ jsx10(
          StickyFooterCloseButton,
          {
            onClose: handleClose,
            className: "mobile-button",
            testId: "close-mobile"
          }
        ),
        /* @__PURE__ */ jsx10("div", { className: "discount-voucher__text-main-block", children: /* @__PURE__ */ jsx10(
          StickyFooterText,
          {
            headlineText: "Grab a \xA325 voucher!",
            descriptionText: "Buy insurance today and choose your reward.",
            disclaimerUrl: `https://www.simplybusiness.co.uk/legal/terms-conditions/${code}/`
          }
        ) })
      ] }),
      /* @__PURE__ */ jsx10(DiscountVoucherButton, { onClick, isPending }),
      /* @__PURE__ */ jsx10(
        StickyFooterCloseButton,
        {
          onClose: handleClose,
          className: "desktop-button",
          testId: "close-desktop"
        }
      )
    ] }),
    /* @__PURE__ */ jsx10(
      DiscountVoucherButton,
      {
        mobile: true,
        onClick,
        isPending
      }
    )
  ] });
};

// src/components/Intervention/Intervention.tsx
import { useEffect as useEffect14, useRef as useRef8, useState as useState12 } from "react";
import equal from "fast-deep-equal/es6/react";

// src/interventions/PricingNudgeIntervention/PricingNudgeIntervention.tsx
import { useCallback, useEffect as useEffect4, useRef as useRef2, useState as useState4 } from "react";
import { Modal as Modal2 } from "@simplybusiness/mobius";

// src/components/PricingNudge/PricingNudge.tsx
import { Box, Button as Button7, Flex as Flex3, Text as Text7 } from "@simplybusiness/mobius";
import { jsx as jsx11, jsxs as jsxs9 } from "react/jsx-runtime";
var PricingNudge = (props) => {
  return /* @__PURE__ */ jsxs9(Box, { className: "mobius-interventions__pricing-nudge", children: [
    /* @__PURE__ */ jsxs9(Flex3, { flexDirection: "column", justifyContent: "center", children: [
      /* @__PURE__ */ jsxs9(
        Text7,
        {
          className: "mobius-interventions__pricing-nudge-text",
          elementType: "h1",
          children: [
            "Want an",
            /* @__PURE__ */ jsxs9("span", { className: "mobius-interventions__pricing-nudge-emphasized-text", children: [
              " ",
              "idea of price",
              " "
            ] }),
            "without needing to answer a lot of questions?"
          ]
        }
      ),
      /* @__PURE__ */ jsx11(
        Text7,
        {
          elementType: "p",
          className: "mobius-interventions__pricing-nudge-subtext",
          children: "Answer four quick questions and we'll let you know what your price could be."
        }
      )
    ] }),
    /* @__PURE__ */ jsx11(Flex3, { rowGap: "lg", columnGap: "lg", justifyContent: "center", children: /* @__PURE__ */ jsx11(
      Button7,
      {
        className: "mobius-interventions__pricing-nudge-cta",
        variant: "primary",
        size: "sm",
        onClick: props.onPriceEstimateButtonClickedCallback,
        children: "Get price estimate"
      }
    ) })
  ] });
};

// src/interventions/PricingNudgeIntervention/PricingNudgeIntervention.tsx
import { jsx as jsx12, jsxs as jsxs10 } from "react/jsx-runtime";
var PricingNudgeIntervention = (props) => {
  const { site, fireEvent } = props;
  const modalViewed = useRef2(false);
  const [showModal, setShowModal] = useState4(true);
  const [shownIPWidget, setShownIPWidget] = useState4(false);
  const showIPWidgetCallback = useCallback(() => {
    fireEvent("hydra_ip_cta_clicked");
    window.showIndicativePricingPopup();
    if (site === "moneysupermarket") convertIPtoMSM();
    setShownIPWidget(true);
    setShowModal(false);
  }, [setShownIPWidget, fireEvent, site]);
  useEffect4(() => {
    if (site == "moneysupermarket") {
      convertNudgeToMSM();
    }
  }, [site]);
  useEffect4(() => {
    if (!modalViewed.current) {
      fireEvent("hydra_ip_modal_viewed");
    }
    modalViewed.current = true;
  }, [fireEvent]);
  useEffect4(() => {
    const handleIPWidgetClosed = (_) => {
      if (shownIPWidget) {
        props.onDismiss?.();
      }
    };
    window.addEventListener("embedded-ip-widget-closed", handleIPWidgetClosed);
    return () => {
      window.removeEventListener(
        "embedded-ip-widget-closed",
        handleIPWidgetClosed
      );
    };
  }, [shownIPWidget, props]);
  return /* @__PURE__ */ jsx12("div", { id: "priceNudgeIntervention", children: /* @__PURE__ */ jsxs10(
    Modal2,
    {
      "data-testid": "pricing-nudge-intervention-modal",
      isOpen: showModal,
      onClose: () => {
        if (!shownIPWidget) {
          fireEvent("hydra_ip_closed_banner");
          setShowModal(false);
          props.onDismiss?.();
        }
      },
      animation: "fade",
      closeLabel: "Close",
      children: [
        /* @__PURE__ */ jsx12(Modal2.Header, { children: "\xA0" }),
        /* @__PURE__ */ jsx12(Modal2.Content, { children: /* @__PURE__ */ jsx12(
          PricingNudge,
          {
            onPriceEstimateButtonClickedCallback: showIPWidgetCallback
          }
        ) })
      ]
    }
  ) });
};

// src/components/ConditionalRenderers/RenderIfShownSuccess.tsx
import { useCallback as useCallback2, useEffect as useEffect5, useRef as useRef3, useState as useState5 } from "react";
var RenderIfShownSuccess = ({ props, children }) => {
  const { fireEvent, fireShown } = props;
  const shownFired = useRef3(false);
  const [childrenToRender, setChildrenToRender] = useState5(null);
  const updateStatus = useCallback2(async () => {
    if (shownFired.current || !fireShown || !fireEvent) {
      return;
    }
    const statusUpdated = await fireShown();
    shownFired.current = true;
    if (!statusUpdated) {
      fireEvent("componentNotShown");
      return;
    }
    fireEvent("componentMounted");
    setChildrenToRender(children);
  }, [fireEvent, fireShown, children]);
  useEffect5(() => {
    void updateStatus();
  }, [updateStatus]);
  return childrenToRender;
};

// src/components/ConditionalRenderers/RenderWhenIPWidgetLoaded.tsx
import { useEffect as useEffect6, useState as useState6 } from "react";
import { Fragment as Fragment3, jsx as jsx13 } from "react/jsx-runtime";
var RenderWhenIPWidgetLoaded = ({ children }) => {
  const [isFoundAndLoaded, setFoundAndLoaded] = useState6(false);
  useEffect6(() => {
    const elementExists = document.getElementById("sb-ip-app");
    const windowFunctionExists = typeof window.showIndicativePricingPopup === "function";
    if (elementExists && windowFunctionExists) setFoundAndLoaded(true);
  }, []);
  return isFoundAndLoaded ? /* @__PURE__ */ jsx13(Fragment3, { children }) : null;
};

// src/components/ConditionalRenderers/RenderIfFooterShown.tsx
import { useEffect as useEffect7, useState as useState7 } from "react";

// src/interventions/PopupControlIntervention/PopupControlIntervention.tsx
import { jsx as jsx14 } from "react/jsx-runtime";
var PopupControlIntervention = (props) => {
  return /* @__PURE__ */ jsx14(RenderIfShownSuccess, { props, children: /* @__PURE__ */ jsx14("div", { "data-testid": "popup-control-intervention" }) });
};

// src/components/TrustBanner/TrustBanner.tsx
import { Image } from "@simplybusiness/mobius";

// src/components/TrustBanner/TrustBannerImages.ts
var TrustBannerImages = {
  trustpilot: {
    src: "data:image/png;base64,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",
    altText: "Simply Business is rated 4 out of 5 stars with over 5,500 reviews on Trustpilot."
  }
};

// src/components/TrustBanner/TrustBanner.tsx
import { jsx as jsx15, jsxs as jsxs11 } from "react/jsx-runtime";
var TrustBanner = () => {
  const imageConfig = TrustBannerImages["trustpilot"];
  return /* @__PURE__ */ jsx15("div", { "data-testid": "trustpilot-test-id", children: /* @__PURE__ */ jsxs11("div", { className: "trust-banner__content", children: [
    /* @__PURE__ */ jsx15(
      Image,
      {
        src: imageConfig.src,
        alt: imageConfig.altText,
        className: "trust-banner__image-trustpilot"
      }
    ),
    /* @__PURE__ */ jsx15("p", { children: "Trust us to find the right insurance for your business" })
  ] }) });
};

// src/hooks/useChopinQuestion/useChopinQuestion.tsx
import { useCallback as useCallback3, useEffect as useEffect8, useRef as useRef4, useState as useState8 } from "react";
var questionAliases = {
  trade_selector: ["primary_trade", "original_shop_type", "profession"]
};
var extractValueFromForm = (form, question) => {
  const data = new FormData(form);
  const value = extractValueFromFormData(data, question);
  if (questionAliases[question] !== void 0) {
    const aliasValues = questionAliases[question].map(
      (alias) => extractValueFromFormData(data, alias)
    );
    return aliasValues.find((aliasValue) => aliasValue) ?? aliasValues.find((aliasValue) => aliasValue !== void 0);
  }
  return value;
};
var extractValueFromFormData = (data, fieldName) => {
  const answer = data.get(fieldName);
  if (!isFieldVisible(fieldName)) return void 0;
  if (!answer || answer === "NaN") return null;
  return answer;
};
var isFieldVisible = (fieldName) => {
  return Array.from(document.getElementsByName(fieldName)).some(
    (el) => {
      const controlBlock = el.closest(".control-block");
      return controlBlock?.classList.contains("on") ?? false;
    }
  );
};
var useChopinQuestion = (question) => {
  const [value, setValue] = useState8(void 0);
  const applyToChopinForm = useCallback3(
    (callback) => {
      const forms = document.querySelectorAll("form");
      for (let f = 0; f < forms.length; f++) {
        const form = forms[f];
        if (!form.action.includes("/q/")) {
          continue;
        }
        callback(form);
      }
    },
    []
  );
  useEffect8(() => {
    applyToChopinForm((form) => {
      form.addEventListener("change", (_) => {
        setValue(extractValueFromForm(form, question));
      });
    });
  }, [question, applyToChopinForm]);
  const loadedInitialValues = useRef4(false);
  if (!loadedInitialValues.current) {
    loadedInitialValues.current = true;
    applyToChopinForm((form) => {
      setValue(extractValueFromForm(form, question));
    });
  }
  return {
    answer: value
  };
};

// src/hooks/useIdle.tsx
import { useCallback as useCallback4, useEffect as useEffect9, useRef as useRef5, useState as useState9 } from "react";
var useIdle = ({ idleTime, onIdle, disable }) => {
  const [isIdle, setIsIdle] = useState9(false);
  const idleTimerRef = useRef5(null);
  const isDisabled = idleTime <= 0 || disable;
  const handleActivity = useCallback4(() => {
    if (isDisabled) return;
    setIsIdle(false);
    if (idleTimerRef.current) clearTimeout(idleTimerRef.current);
    idleTimerRef.current = setTimeout(() => {
      setIsIdle(true);
      onIdle?.().catch(console.error);
    }, idleTime);
  }, [idleTime, isDisabled, onIdle]);
  useEffect9(() => {
    handleActivity();
  }, [handleActivity]);
  useEffect9(() => {
    if (isDisabled) return;
    const events = ["click", "mousemove", "keydown", "scroll"];
    events.forEach((event) => window.addEventListener(event, handleActivity));
    return () => {
      if (idleTimerRef.current) clearTimeout(idleTimerRef.current);
      events.forEach(
        (event) => window.removeEventListener(event, handleActivity)
      );
    };
  }, [handleActivity, isDisabled]);
  return isIdle;
};

// src/hooks/useInactivity/useInactivity.tsx
import { useState as useState10, useRef as useRef6, useEffect as useEffect10 } from "react";
var useInactivity = () => {
  const inactivityRef = useRef6(null);
  const [isInactive, setIsInactive] = useState10(false);
  useEffect10(() => {
    if (!inactivityRef.current) {
      inactivityRef.current = new inactivity_service_default(setIsInactive);
      inactivityRef.current.start();
    }
    return () => {
      inactivityRef.current?.stop();
    };
  }, []);
  return isInactive;
};

// src/hooks/useInterval.ts
import { useEffect as useEffect11, useRef as useRef7 } from "react";
var useInterval = (callback, delay) => {
  const savedCallback = useRef7(null);
  useEffect11(() => {
    savedCallback.current = callback;
  }, [callback]);
  useEffect11(() => {
    const tick = () => {
      savedCallback?.current?.();
    };
    if (delay !== null) {
      const id = setInterval(tick, delay);
      return () => {
        clearInterval(id);
      };
    }
  }, [delay]);
};

// src/hooks/usePreload/usePreload.tsx
import { useEffect as useEffect12 } from "react";
var usePreload = (imageAsString) => {
  useEffect12(() => {
    if (imageAsString === "") return;
    const link = document.createElement("link");
    link.rel = "preload";
    link.as = "image";
    link.href = imageAsString;
    document.head.appendChild(link);
  }, [imageAsString]);
};

// src/interventions/EmbedTrustPlatformBanner/EmbedTrustPlatformBanner.tsx
import { jsx as jsx16 } from "react/jsx-runtime";
var EmbedTrustPlatformBanner = (props) => {
  usePreload(TrustBannerImages["trustpilot"].src);
  return /* @__PURE__ */ jsx16(RenderIfShownSuccess, { props, children: /* @__PURE__ */ jsx16(TrustBanner, {}) });
};

// src/components/TradeBased/TradeBasedInline/TradeBasedInline.tsx
import { Box as Box2, Flex as Flex4, Icon as Icon6, Text as Text8 } from "@simplybusiness/mobius";
import { lightbulbOn as lightbulbOn2 } from "@simplybusiness/icons";
import { jsx as jsx17, jsxs as jsxs12 } from "react/jsx-runtime";

// src/components/TradeBased/TradeBasedFooter/TradeBasedFooter.tsx
import { Flex as Flex5 } from "@simplybusiness/mobius";
import { useEffect as useEffect13 } from "react";
import { jsx as jsx18 } from "react/jsx-runtime";

// src/components/TradeBased/TradeBasedPopup/TradeBasedPopup.tsx
import { useState as useState11 } from "react";
import {
  Box as Box3,
  Modal as Modal3,
  Button as Button8,
  Flex as Flex6,
  Text as Text9,
  Logo,
  Icon as Icon7,
  Image as Image2
} from "@simplybusiness/mobius";
import { cross as cross2 } from "@simplybusiness/icons";

// src/components/TradeBased/homebuilderImage.ts
var homebuilder = "data:image/png;base64,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";

// src/components/TradeBased/TradeBasedPopup/TradeBasedPopup.tsx
import { Fragment as Fragment4, jsx as jsx19, jsxs as jsxs13 } from "react/jsx-runtime";
var WhichLogo = ({ isMSM }) => {
  if (isMSM) {
    return /* @__PURE__ */ jsx19("span", { className: "mobius-interventions__trade-based-msm-logo" });
  }
  return /* @__PURE__ */ jsxs13(Fragment4, { children: [
    /* @__PURE__ */ jsx19(Logo, { className: "mobius-interventions__trade-based-logo" }),
    /* @__PURE__ */ jsx19("span", { className: "mobius-interventions__trade-based-mobile-logo" })
  ] });
};
var TradeBasedPopup = (props) => {
  const [showModal, setShowModal] = useState11(true);
  const { mainText, finePrint, fireEvent, site } = props;
  if (!site || !fireEvent) return null;
  const isMSM = site === "moneysupermarket";
  const buildContinueButton = (cssClass) => {
    return /* @__PURE__ */ jsx19(
      Button8,
      {
        className: cssClass,
        "data-testid": cssClass,
        "aria-label": "Go back to your quote",
        variant: "primary",
        size: "sm",
        onPress: () => {
          setShowModal(false);
          props.onDismiss?.();
          fireEvent("cta_clicked");
        },
        children: "Continue your quote"
      }
    );
  };
  return /* @__PURE__ */ jsxs13(
    Modal3,
    {
      className: "mobius-interventions__trade-based",
      "data-testid": "trade-based-claims-modal",
      isOpen: showModal,
      children: [
        /* @__PURE__ */ jsxs13(Modal3.Header, { children: [
          /* @__PURE__ */ jsx19(WhichLogo, { isMSM }),
          /* @__PURE__ */ jsxs13(
            Button8,
            {
              className: `mobius-interventions__trade-based-close-button${isMSM ? `-msm` : ""}`,
              variant: "ghost",
              size: "sm",
              onPress: () => {
                setShowModal(false);
                props.onDismiss?.();
                fireEvent("modal_closed");
              },
              children: [
                /* @__PURE__ */ jsx19(Icon7, { icon: cross2 }),
                " Close"
              ]
            }
          )
        ] }),
        /* @__PURE__ */ jsxs13(Modal3.Content, { children: [
          /* @__PURE__ */ jsx19(Box3, { children: /* @__PURE__ */ jsxs13(
            Flex6,
            {
              className: "mobius-interventions__trade-based-wrapper",
              rowGap: "sm",
              children: [
                /* @__PURE__ */ jsxs13(
                  Flex6,
                  {
                    className: "mobius-interventions__trade-based-text-flexbox",
                    flexDirection: "column",
                    justifyContent: "left",
                    children: [
                      /* @__PURE__ */ jsx19(
                        Text9,
                        {
                          "data-testid": "trade-based-claims-text-test-id",
                          className: `mobius-interventions__trade-based-text${isMSM ? `-msm` : ""}`,
                          elementType: "h2",
                          children: mainText
                        }
                      ),
                      buildContinueButton(
                        "mobius-interventions__trade-based-cta-desktop"
                      )
                    ]
                  }
                ),
                /* @__PURE__ */ jsx19(
                  Image2,
                  {
                    src: homebuilder,
                    alt: "",
                    className: "mobius-interventions__trade-based-homebuilder"
                  }
                ),
                buildContinueButton(
                  "mobius-interventions__trade-based-cta-mobile"
                )
              ]
            }
          ) }),
          /* @__PURE__ */ jsx19(Box3, { children: /* @__PURE__ */ jsxs13(
            Text9,
            {
              "data-testid": "trade-based-claims-disclaimer-test-id",
              className: "mobius-interventions__trade-based-text-fineprint",
              elementType: "p",
              children: [
                " ",
                finePrint
              ]
            }
          ) })
        ] })
      ]
    }
  );
};

// src/interventions/TradeBasedAverageClaims/TradeBasedAverageClaims.tsx
import { jsx as jsx20 } from "react/jsx-runtime";
var getMainText = (amount) => {
  return `Over the last 2 years, the average claim was ${amount} for someone in your trade. 93% of settled claims get processed in less than 48 hours.*`;
};
var getFinePrint = (trade, amount) => {
  return `*The average claim value for ${trade} between 1st January 2023 and 31st December 2024 was ${amount}. We define settled claims as a claim that has been agreed by all parties that a payment can be made. It can take longer from a claim being raised to it being settled and paid.`;
};
var TradeBasedAverageClaims = (props) => {
  usePreload(homebuilder);
  const { data } = props;
  if (!data?.contextData || !data?.contextData?.ClaimsText || !data?.contextData?.PluralizedFriendlyTradeName)
    return null;
  const claimsAmount = data.contextData.ClaimsText;
  const tradeName = data.contextData.PluralizedFriendlyTradeName;
  return /* @__PURE__ */ jsx20(RenderIfShownSuccess, { props, children: /* @__PURE__ */ jsx20(
    TradeBasedPopup,
    {
      ...props,
      mainText: getMainText(claimsAmount),
      finePrint: getFinePrint(tradeName, claimsAmount)
    }
  ) });
};

// src/interventions/interventionComponentList.tsx
import { jsx as jsx21 } from "react/jsx-runtime";
var getInterventionComponent = (props, componentName) => {
  switch (componentName) {
    case "control":
    case "popup-control":
      return /* @__PURE__ */ jsx21(PopupControlIntervention, { ...props });
    case "indicative-pricing":
      return /* @__PURE__ */ jsx21(RenderWhenIPWidgetLoaded, { children: /* @__PURE__ */ jsx21(RenderIfShownSuccess, { props, children: /* @__PURE__ */ jsx21(PricingNudgeIntervention, { ...props }) }) });
    case "claims-popup-average":
      return /* @__PURE__ */ jsx21(TradeBasedAverageClaims, { ...props });
    case "embed-trust-platform-trustpilot":
      return /* @__PURE__ */ jsx21(EmbedTrustPlatformBanner, { ...props });
    default:
      break;
  }
  return null;
};

// src/components/ErrorBoundary/ErrorBoundary.tsx
import { Component } from "react";
var ErrorBoundary = class extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    this.setState({ hasError: true });
    const airbrake6 = getAirbrake();
    void airbrake6.notify({
      error: error.message,
      params: {
        source: "mobius-interventions",
        component: "ErrorBoundary",
        userId: this.props.duid,
        site: this.props.site,
        info,
        stackTrace: error.stack,
        componentStack: info.componentStack
      }
    });
  }
  render() {
    return this.state.hasError ? null : this.props.children;
  }
};

// src/components/Intervention/Intervention.tsx
import { jsx as jsx22 } from "react/jsx-runtime";
var airbrake3 = getAirbrake();
var Intervention = (props) => {
  const listenerRef = useRef8(null);
  const [eventData, setEventData] = useState12(null);
  useEffect14(() => {
    if (!listenerRef.current) {
      listenerRef.current = (event) => {
        const data = event.detail;
        if (data.interventionName !== props.interventionName) {
          return;
        }
        if (data.componentName !== props.componentName) {
          return;
        }
        if (!data.message) {
          return;
        }
        setEventData((previousValue) => {
          if (equal(previousValue?.message, data.message)) {
            return previousValue;
          }
          return data;
        });
      };
    }
    window.addEventListener("intervention-event", listenerRef.current);
    return () => {
      if (listenerRef.current) {
        window.removeEventListener("intervention-event", listenerRef.current);
      }
    };
  }, [props, setEventData]);
  if (!eventData?.message) {
    return null;
  }
  const interventionProps = {
    site: props.site,
    duid: props.duid,
    fireEvent: eventData?.fireEvent,
    data: eventData?.message,
    fireShown: () => {
      if (eventData?.onPopupShow) eventData.onPopupShow();
      return updateInterventionStatus(
        props.duid,
        props.interventionName,
        props.site
      );
    }
  };
  interventionProps.onDismiss = eventData?.onPopupClose;
  const component = getInterventionComponent(
    interventionProps,
    props.componentName
  );
  if (!component) {
    void airbrake3.notify({
      error: new Error(
        "Component not found in interventionComponentList: " + props.componentName
      ),
      params: {
        source: "mobius-interventions",
        component: "Intervention",
        userId: props.duid
      }
    });
    return null;
  }
  return /* @__PURE__ */ jsx22(ErrorBoundary, { duid: props.duid, site: props.site, children: component });
};

// src/components/UserActionListener/UserActionListener.tsx
import { useEffect as useEffect15, useMemo, useRef as useRef9, useState as useState13 } from "react";

// src/utils/idm-emitter.ts
var airbrake4 = getAirbrake();
var IDMEmitter = class {
  constructor(userId, site, eligibilityData, interventionReceivedCallback, options2) {
    this.start = () => {
      this.intervalId = this.startPolling();
    };
    this.stop = () => {
      this.stopPolling();
    };
    this.isPolling = () => {
      return this.intervalId !== void 0;
    };
    this.pollNow = () => {
      this.callAPI();
    };
    this.setEligibilityData = (data) => {
      this.eligibilityData = data;
    };
    this.startPolling = () => {
      this.callAPI();
      return window.setInterval(this.callAPI, this.intervalFrequency);
    };
    this.stopPolling = () => {
      clearInterval(this.intervalId);
      this.intervalId = void 0;
    };
    this.callAPI = () => {
      this.fetchInterventions().catch((error) => {
        console.error("Error fetching interventions:", error);
      });
    };
    this.fetchInterventions = async () => {
      try {
        const response = await fetch(`${this.idmApiUrl}/interventions`, {
          ...IDM_POST_OPTIONS,
          body: JSON.stringify({
            system_user_id: this.userId,
            site: this.site,
            eligibility_data: this.eligibilityData
          })
        });
        const data = await response.json();
        const interventionNames = Object.keys(data);
        for (const interventionName of interventionNames) {
          if (data[interventionName].show === false) continue;
          if (data[interventionName].component_names === void 0) {
            void airbrake4.notify({
              error: new Error(
                "No component names provided for intervention with show: true, " + interventionName
              ),
              params: {
                source: "mobius-interventions",
                userId: this.userId,
                site: this.site
              }
            });
            continue;
          }
          if (data[interventionName].category === void 0) continue;
          this.interventionReceivedCallback(
            interventionName,
            data[interventionName].component_names,
            data[interventionName].category,
            data[interventionName].context_data
          );
        }
      } catch (error) {
        this.stopPolling();
        console.error("Error fetching interventions from IDM API:", error);
        void airbrake4.notify({
          error,
          params: {
            source: "mobius-interventions",
            userId: this.userId,
            site: this.site
          }
        });
      }
    };
    this.idmApiUrl = IDM_API_URLS();
    this.userId = userId;
    this.site = site;
    this.intervalId = void 0;
    this.eligibilityData = eligibilityData;
    this.intervalFrequency = options2?.intervalFrequency || DEFAULT_POLLING_INTERVAL;
    this.interventionReceivedCallback = interventionReceivedCallback;
  }
};
var idm_emitter_default = IDMEmitter;

// src/utils/curateProps.ts
var curateProps = (enrichedProps, activity) => {
  const eligibilityData = { ...activity };
  if (enrichedProps.trade !== void 0) {
    eligibilityData.trade = enrichedProps.trade;
  }
  if (enrichedProps.annualTurnover !== void 0) {
    eligibilityData.annualTurnover = enrichedProps.annualTurnover;
  }
  if (enrichedProps.yearsTrading !== void 0) {
    eligibilityData.yearsTrading = enrichedProps.yearsTrading;
  }
  if (enrichedProps.ukPostcode !== void 0) {
    eligibilityData.ukPostcode = enrichedProps.ukPostcode;
  }
  if (enrichedProps.businessType !== void 0) {
    eligibilityData.businessType = enrichedProps.businessType;
  }
  if (enrichedProps.town !== void 0) {
    eligibilityData.town = enrichedProps.town;
  }
  if (enrichedProps.popupShowing) {
    eligibilityData.popupShowing = enrichedProps.popupShowing;
  }
  return eligibilityData;
};

// src/components/UserActionListener/UserActionListener.tsx
var UserActionListener = (props) => {
  const site = props.site;
  const geoRegion = props.geoRegion;
  const duid = props.duid;
  const snowplowRef = useRef9(props.snowplowInstance);
  const idmEmitter = useRef9(null);
  const [interventions, setInterventions] = useState13({});
  const { answer: trade } = useChopinQuestion("trade_selector");
  const { answer: turnover } = useChopinQuestion("annual_turnover");
  const { answer: yearsTrading } = useChopinQuestion("years_trading");
  const { answer: postcode } = useChopinQuestion("uk_postcode");
  const { answer: businessType } = useChopinQuestion("business_type");
  const { answer: town } = useChopinQuestion("town");
  const isInactive = useInactivity();
  const [popupShowing, setPopupShowing] = useState13(null);
  const publishInterventionEvent = (interventionName, componentName, category, message) => {
    const event = {
      interventionName,
      componentName,
      message
    };
    if (category == "popup" && !componentName.includes("control")) {
      event["onPopupShow"] = () => setPopupShowing(interventionName);
      event["onPopupClose"] = () => setPopupShowing(null);
    }
    event["fireEvent"] = (action) => {
      void snowplowRef.current.trackUnstructEvent(
        buildInterventionEventBody(
          interventionName,
          message.chopinPageData.duid,
          message.chopinPageData.site,
          action
        )
      );
    };
    window.dispatchEvent(
      new CustomEvent("intervention-event", {
        detail: event
      })
    );
  };
  const enrichedProps = useMemo(() => {
    const { snowplowInstance, ...chopinPageData } = props;
    const updated = {
      popupShowing,
      ...chopinPageData
    };
    if (updated.primaryTrade) {
      updated.trade = updated.primaryTrade;
    } else if (updated.originalShopType) {
      updated.trade = updated.originalShopType;
    } else if (updated.profession) {
      updated.trade = updated.profession;
    }
    if (trade !== void 0) {
      updated.trade = trade;
    }
    if (turnover !== void 0) {
      updated.annualTurnover = turnover;
    }
    if (yearsTrading !== void 0) {
      updated.yearsTrading = yearsTrading;
    }
    if (postcode !== void 0) {
      updated.ukPostcode = postcode;
    }
    if (town !== void 0) {
      updated.town = town;
    }
    if (businessType !== void 0) {
      updated.businessType = businessType;
    }
    return updated;
  }, [
    props,
    trade,
    turnover,
    yearsTrading,
    postcode,
    town,
    businessType,
    popupShowing
  ]);
  useEffect15(() => {
    Object.entries(interventions).forEach(([interventionName, components]) => {
      components.componentNames.forEach((componentName) => {
        const interventionMessage = {
          show: true,
          //@TODO: currently hardcoded. AHOY-3303 contains some detail about possible implementations to undo this.
          chopinPageData: enrichedProps,
          contextData: components.contextData
        };
        publishInterventionEvent(
          interventionName,
          componentName,
          components.category,
          interventionMessage
        );
      });
    });
  }, [interventions, enrichedProps]);
  const curatedProps = useMemo(() => {
    return curateProps(enrichedProps, { inactive: isInactive });
  }, [enrichedProps, isInactive]);
  useEffect15(() => {
    if (!duid) return;
    if (idmEmitter.current) return;
    const interventionReceivedCallback = (interventionName, componentNames, category, contextData) => {
      setInterventions((prev) => {
        return {
          ...prev,
          [interventionName]: {
            componentNames,
            category,
            contextData
          }
        };
      });
    };
    idmEmitter.current = new idm_emitter_default(
      duid,
      site,
      curatedProps,
      interventionReceivedCallback
    );
    idmEmitter.current.start();
  }, [duid, site, setInterventions, interventions, curatedProps]);
  useEffect15(() => {
    if (idmEmitter.current) {
      idmEmitter.current.setEligibilityData(curatedProps);
      idmEmitter.current.pollNow();
    }
  }, [curatedProps]);
  if (!site) {
    console.error("A site prop is required for UserActionListener to work");
  }
  if (!geoRegion) {
    console.error(
      "A geoRegion prop is required for UserActionListener to work"
    );
  }
  return null;
};

// src/components/Interventions/Interventions.tsx
import { jsx as jsx23 } from "react/jsx-runtime";
var Interventions = (props) => {
  if (!props.duid) {
    void getAirbrake().notify({
      error: new Error("A DUID is required for Interventions to work"),
      params: {
        source: "mobius-interventions",
        component: "Interventions",
        userId: null
      }
    });
    return null;
  }
  const snowplowInstance = getSnowplow({
    uid: props.uid,
    duid: props.duid,
    appId: props.snowplowAppId,
    avalancheCollector: props.avalancheCollector,
    cookieDomain: props.snowplowCookieDomain,
    site: props.site
  });
  return /* @__PURE__ */ jsx23(UserActionListener, { ...props, snowplowInstance });
};

// src/components/QCPInactivityIntervention/QCPInactivityIntervention.tsx
import { Button as Button10, Modal as Modal4, Text as Text11 } from "@simplybusiness/mobius";
import { useState as useState14, useRef as useRef10 } from "react";

// src/components/QCPInactivityIntervention/utils.tsx
import { telephone } from "@simplybusiness/icons";
import { Button as Button9, Icon as Icon8, Text as Text10 } from "@simplybusiness/mobius";

// src/components/QCPInactivityIntervention/phoneNumbers.tsx
var phoneNumbers = {
  workers_compensation: {
    display: "(855) 940-2484",
    href: "+18559402484"
  },
  usa: {
    display: "(855) 699-4041",
    href: "+18556994041"
  },
  business_owners_policy: {
    display: "(855) 467-7810",
    href: "+18554677810"
  }
};
var getPhoneNumber = (interventionVersion) => {
  return phoneNumbers[interventionVersion] ?? {
    display: "(855) 699-4041",
    href: "+18556994041"
  };
};

// src/components/QCPInactivityIntervention/utils.tsx
import { Fragment as Fragment5, jsx as jsx24, jsxs as jsxs14 } from "react/jsx-runtime";
var getCallOrChatVariant = (contactVariant, vertical, setIsOpen, fireEvent) => {
  const handleChatClick = () => {
    if (window?.zE) {
      setIsOpen(false);
      fireEvent?.("qcp_modal_chat_opened");
      window.zE("messenger", "show");
      window.zE("messenger", "open");
    }
  };
  const phoneNumber = getPhoneNumber(vertical);
  switch (contactVariant) {
    case "call":
      return /* @__PURE__ */ jsxs14(Fragment5, { children: [
        /* @__PURE__ */ jsxs14("div", { className: "qcp-inactivity-intervention__qcp-phone-number qcp-inactivity-intervention__desktop-only", children: [
          /* @__PURE__ */ jsx24(
            Icon8,
            {
              icon: telephone,
              size: "md",
              color: "var(--color-bubblegum-500)"
            }
          ),
          /* @__PURE__ */ jsx24(
            Text10,
            {
              className: "qcp-inactivity-intervention__qcp-phone-number-text",
              elementType: "h3",
              children: phoneNumber.display
            }
          )
        ] }),
        /* @__PURE__ */ jsx24("a", { href: `tel:${phoneNumber.href}`, children: /* @__PURE__ */ jsx24(
          Button9,
          {
            "data-testid": "qcp-inactivity-call-us-button",
            className: "qcp-inactivity-intervention__button qcp-inactivity-intervention__mobile-only",
            variant: "primary",
            size: "sm",
            onClick: () => {
              fireEvent?.("qcp_modal_phone_call_opened");
            },
            children: "Call Us"
          }
        ) })
      ] });
    case "chat":
      return /* @__PURE__ */ jsx24(
        Button9,
        {
          "data-testid": "qcp-inactivity-chat-button",
          className: "qcp-inactivity-intervention__button qcp-inactivity-intervention__agent-chat-button",
          variant: "primary",
          size: "sm",
          onClick: handleChatClick,
          children: "Chat With an Agent"
        }
      );
  }
};
var getInterventionTitle = (type) => {
  switch (type) {
    case "wc":
      return "Let's review your Workers' Comp quotes together!";
    case "gl":
      return "Let's review your General Liability quotes together!";
    case "generic":
      return /* @__PURE__ */ jsxs14(Fragment5, { children: [
        "Let's review your quotes",
        /* @__PURE__ */ jsx24("br", {}),
        "together!"
      ] });
  }
};
var getTrade = (trade) => {
  trade = trade.toLowerCase();
  switch (trade) {
    case "handyperson":
      trade = "handyman";
      break;
    case "janitorial services":
      trade = "janitorial";
      break;
    case "painting and wall covering contractors":
      trade = "painting & wallpaper";
      break;
    case "trucking & transportation services":
      trade = "trucking & transportation";
      break;
    case "landscaping services":
      trade = "landscaping";
      break;
    case "general contractor":
      trade = "general contracting";
      break;
  }
  return trade;
};

// src/components/QCPInactivityIntervention/QCPInactivityIntervention.tsx
import { jsx as jsx25, jsxs as jsxs15 } from "react/jsx-runtime";
var QCPInactivityIntervention = (props) => {
  const { fireEvent } = props;
  const displayTrade = getTrade(props.trade);
  const vertical = props.vertical;
  const { component_names } = props.data || {};
  const componentType = component_names?.[0] || "";
  const [isOpen, setIsOpen] = useState14(true);
  const parseComponentType = (componentType2) => {
    const parts = componentType2.split("-");
    const interventionVersion2 = parts[3];
    const contactVariant2 = parts[4];
    return { interventionVersion: interventionVersion2, contactVariant: contactVariant2 };
  };
  const { interventionVersion, contactVariant } = parseComponentType(componentType);
  const interventionSubtext = interventionVersion === "generic" ? "You can get personalized help from our small business specialists." : `You can get personalized help from our ${displayTrade} specialists.`;
  const title = getInterventionTitle(interventionVersion);
  const variant = getCallOrChatVariant(
    contactVariant,
    vertical,
    setIsOpen,
    fireEvent
  );
  const hasFiredEventRef = useRef10(false);
  return contactVariant === "control" ? /* @__PURE__ */ jsx25("div", {}) : /* @__PURE__ */ jsxs15(
    Modal4,
    {
      className: "qcp-inactivity-intervention__qcp-intervention-modal",
      isOpen,
      onOpen: () => {
        if (hasFiredEventRef.current) return;
        fireEvent?.("qcp_modal_shown");
        hasFiredEventRef.current = true;
      },
      animation: "fade",
      children: [
        /* @__PURE__ */ jsx25("div", { className: "qcp-inactivity-intervention__qcp-content-container", children: /* @__PURE__ */ jsxs15("div", { className: "qcp-inactivity-intervention__qcp-text-container", children: [
          /* @__PURE__ */ jsx25(Text11, { elementType: "h2", children: title }),
          /* @__PURE__ */ jsx25(
            Text11,
            {
              className: "qcp-inactivity-intervention__qcp-subtext",
              elementType: "p",
              children: interventionSubtext
            }
          ),
          variant,
          /* @__PURE__ */ jsx25(
            Button10,
            {
              "data-testid": "qcp-inactivity-back-button",
              className: `qcp-inactivity-intervention__button qcp-inactivity-intervention__bottom-button ${contactVariant === "chat" ? "qcp-inactivity-intervention__full-width-button" : ""}`,
              variant: "secondary",
              size: "sm",
              onClick: () => {
                setIsOpen(false);
                fireEvent?.("qcp_modal_closed");
              },
              children: "Back to Quotes"
            }
          )
        ] }) }),
        /* @__PURE__ */ jsx25("div", { className: "qcp-inactivity-intervention__qcp-image" })
      ]
    }
  );
};

// src/components/ReactInterventionWrapper/InterventionWrapper.tsx
import { useSnowplowContext } from "@simplybusiness/services";
import { cloneElement, useCallback as useCallback6, useEffect as useEffect16, useRef as useRef11, useState as useState15 } from "react";

// src/contexts/InterventionsProvider/EventEmitter.ts
var EventEmitter = class {
  constructor() {
    this.events = {};
  }
  on(event, listener) {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].push(listener);
  }
  off(event) {
    if (this.events[event]) {
      delete this.events[event];
    }
  }
  emit(event, data) {
    const listeners = this.events[event];
    if (listeners) {
      listeners.forEach((listener) => listener(data));
    }
  }
};

// src/contexts/InterventionsProvider/InterventionsProvider.tsx
import {
  createContext,
  useCallback as useCallback5,
  useContext,
  useMemo as useMemo2
} from "react";

// src/contexts/InterventionsProvider/fetchers.tsx
import { getAirbrake as getAirbrake2 } from "@simplybusiness/services";
var options = {
  method: "POST",
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json"
  }
};
var baseUrl = IDM_API_URLS();
var airbrake5 = getAirbrake2({
  projectId: AIRBRAKE_PROJECT_ID,
  projectKey: AIRBRAKE_PROJECT_KEY
});
var fetchInterventions = async ({
  duid,
  site,
  apiUrl,
  ...extraData
}) => {
  try {
    const response = await fetch(`${apiUrl ?? baseUrl}/interventions`, {
      ...options,
      body: JSON.stringify({
        system_user_id: duid,
        site,
        ...extraData
      })
    });
    const data = await response.json();
    return data;
  } catch (error) {
    if (true) {
      airbrake5.notify(error);
    }
    throw error;
  }
};
var setInterventionShown = async ({
  duid,
  interventionName,
  apiUrl,
  site
}) => {
  try {
    const response = await fetch(`${apiUrl ?? baseUrl}/intervention/shown`, {
      ...options,
      body: JSON.stringify({
        system_user_id: duid,
        site,
        intervention_name: interventionName
      })
    });
    const result = await response.json();
    return result;
  } catch (error) {
    airbrake5.notify(error);
    return false;
  }
};

// src/contexts/InterventionsProvider/InterventionsProvider.tsx
import { jsx as jsx26 } from "react/jsx-runtime";
var InterventionsContext = createContext(null);
var InterventionsProvider = ({
  site,
  duid,
  inactivityTime,
  disablePolling = false,
  apiUrl,
  children
}) => {
  const eventEmitter = useMemo2(
    () => new EventEmitter(),
    []
  );
  const sendMessages = useCallback5(
    (message) => {
      Object.entries(message).forEach(([name, intervention]) => {
        if (intervention.show) {
          eventEmitter.emit(name, intervention);
        }
      });
    },
    [eventEmitter]
  );
  const pollApi = useCallback5(async () => {
    try {
      const data = await fetchInterventions({
        duid,
        site,
        apiUrl
      });
      sendMessages(data);
    } catch (error) {
      console.log(error);
    }
  }, [duid, sendMessages, site, apiUrl]);
  const sendInactivity = useCallback5(async () => {
    try {
      const data = await fetchInterventions({
        duid,
        site,
        apiUrl,
        eligibility_data: {
          inactive: true
        }
      });
      sendMessages(data);
    } catch (error) {
      console.log(error);
    }
  }, [apiUrl, duid, sendMessages, site]);
  useIdle({
    idleTime: inactivityTime ?? 0,
    onIdle: sendInactivity,
    disable: disablePolling
  });
  useInterval(() => {
    if (duid && site && !disablePolling) {
      void pollApi();
    }
  }, DEFAULT_POLLING_INTERVAL);
  const setShown = useCallback5(
    async (interventionName) => {
      const result = await setInterventionShown({
        duid,
        interventionName,
        site
      });
      return result;
    },
    [duid, site]
  );
  const value = useMemo2(
    () => ({
      eventEmitter,
      duid,
      site,
      setShown
    }),
    [eventEmitter, duid, site, setShown]
  );
  return /* @__PURE__ */ jsx26(InterventionsContext.Provider, { value, children });
};
var useInterventions = () => {
  const context = useContext(InterventionsContext);
  if (!context) {
    throw new Error(
      "useInterventions must be used within an InterventionsProvider"
    );
  }
  return context;
};

// src/components/ReactInterventionWrapper/InterventionWrapper.tsx
var InterventionWrapper = ({
  name,
  children
}) => {
  const { eventEmitter, duid, site, setShown } = useInterventions();
  const hasSentShownEvent = useRef11(false);
  const [interventionData, setInterventionData] = useState15(null);
  const { snowplow } = useSnowplowContext();
  const [show, setShow] = useState15(false);
  const onDismiss = () => {
    setShow(false);
    eventEmitter?.off(name);
  };
  const fireEvent = useCallback6(
    (action) => snowplow?.trigger("interventionInteractionCompleted", {
      interventionName: name,
      userUniqueIdentifier: duid,
      userUniqueIdentifierType: "duid",
      action,
      site
    }),
    [duid, name, site, snowplow]
  );
  useEffect16(() => {
    eventEmitter?.on(name, (data) => {
      if (!duid) return;
      setInterventionData(data);
      if (data.show) {
        setShow(true);
        if (!hasSentShownEvent.current) {
          setShown(name).catch(console.error);
          hasSentShownEvent.current = true;
        }
      }
    });
    return () => eventEmitter?.off(name);
  }, [eventEmitter, name, setShown, duid]);
  if (!show || !duid) {
    return null;
  }
  return cloneElement(
    children,
    {
      data: interventionData,
      onDismiss,
      fireEvent,
      duid
      // Not needed in React SSR pages, but required for HAML versions
    }
  );
};

// src/components/ReassuranceIntervention/ReassuranceIntervention.tsx
import { useState as useState16 } from "react";
import { lightbulbOn as lightbulbOn3 } from "@simplybusiness/icons";
import { Icon as Icon9 } from "@simplybusiness/mobius";
import { jsx as jsx27, jsxs as jsxs16 } from "react/jsx-runtime";
var ReassuranceIntervention = (props) => {
  const { onDismiss } = props;
  const [hidden, setHidden] = useState16(false);
  const handleCloseClick = () => {
    setHidden(true);
    if (onDismiss) onDismiss();
  };
  return /* @__PURE__ */ jsxs16(StickyFooter, { hidden, children: [
    /* @__PURE__ */ jsxs16("div", { className: "reassurance__text", children: [
      /* @__PURE__ */ jsx27(
        Icon9,
        {
          icon: lightbulbOn3,
          size: "md",
          className: "reassurance__text-icon",
          "data-testid": "reassurance__text-icon"
        }
      ),
      /* @__PURE__ */ jsx27(
        StickyFooterCloseButton,
        {
          onClose: handleCloseClick,
          className: "mobile-button",
          testId: "close-mobile"
        }
      ),
      /* @__PURE__ */ jsx27("div", { className: "reassurance__text-main-block", children: /* @__PURE__ */ jsx27(
        StickyFooterText,
        {
          headlineText: "We've got you covered!",
          descriptionText: "With 20 years of experience, Simply Business is the expert choice for small business insurance. Over 550,000 UK businesses trusted us in 2024 alone."
        }
      ) })
    ] }),
    /* @__PURE__ */ jsx27(
      StickyFooterCloseButton,
      {
        onClose: handleCloseClick,
        className: "desktop-button",
        testId: "close-desktop"
      }
    )
  ] });
};

// src/components/StarRatingIntervention/StarRatingIntervention.tsx
import { useState as useState17 } from "react";
import { lightbulbOn as lightbulbOn4 } from "@simplybusiness/icons";
import { Icon as Icon10 } from "@simplybusiness/mobius";

// src/components/StarRatingIntervention/StarRatingImages.tsx
import { Image as Image3 } from "@simplybusiness/mobius";

// src/components/StarRatingIntervention/StarRatingImageData.ts
var StarRatingImageData = [
  {
    imageSrc: "data:image/png;base64,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",
    caption: "Feefo Service Rating"
  },
  {
    imageSrc: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMEAAAA8CAYAAADfTt5bAAAiP0lEQVR4Ae1dB1yV1fv/soeAbFAQBETBPXDvvVfuNHOmpWlWVr+WaWp/y8pyb3/ONPdquEdmDtwKqIAgyFYcDBHe//M8d3i5oQwh/eX99rnhPe/7nveM5znPPOcagbBo+Qbl/oN0GBnBAANeCig5ObCxKYWeXVq2NOWC7OwcjB7ej64oMMCAlwEmJsZY+/MuODs7w1RVpMDC3AzGxsYwwICXBmrNx0D1BrzEUHGBgQkMeOlhYAIDXnoYmMCAlx4GJjDgpYeBCQx46VFiTJBDwYiSRFZWFvJ7v24bsrOzURgoFDN59OiR/Dsl5bb6nY/wPJFfnzUo7rEvrvoePnyY6/ujQs5JScEUJQCeLCMKP5dk3MHMzAxfTv8aZ86dh7W1tQT6HlHQz7e8F94ZNwauLs5IS09H/0HDUNrOFssXz8u3Tp7sW3FxMDczpyCKE0xNTfH9j3Px7jvj8NWMb/DRxHfxPMF9nr9oGXbu+gUOjg60gpGLj8ZZUXLAYc74hETM+2Em/Cv4oTjBc3nnTiru338AFxcnmJubS1lhwc8tWvpfLF68FN9+8xWaNW2MFwHFzgRpaWny19LSEiWN02fO4cCBQzC3oEkhQniYmYG7NFmzZ/+IKxfPw5EI5dChQ7C1K619hld4/QnUlCUlJ6O8X0UEBlbF+eDjco0Z2tjElKRC7tWQGUafyfOuG9p0FCbUJ5EO18fP5kdcJ06dxr7fd8PCyhZWNnYyzndTU5H9KAtp924jNfVzFKSv+ZVJm6jcWN2mkW+Nx8Z1q/DHH3+iUaN6T3zmSeUahISE4dRfR2SxeVFQrEv13bt3kZmZ+Y9FnkuVssa91DuYP3sWYqOuI4Y+w94YgawcE4waOwFWVlYkJUoRE9jJ/ZoJuv/gAcIjbiAuPkFbnpn5kAjoLszMrWBburQwc1paOj547x1ERoTj0/+8L+I7PiEB6RkZ0sc4msgbUTe17eF6eMVMSEzUUSFUZYmJSZKvwuMTExsrV1jdunY9HHeIiLk+bhu34XpEpLZOTmnRgOv84dsZiIqKRHzsDTRqWB83oyKwcN4PiI4IRXTUDVSrVgWxt+LkOa4vOSWF3pONxKQkaYduXQnUptt37uRSd6JvxlCbImgu7wkDcBtZjbGysoSRmSUyH2bKuHBfFXWaTVJSsozngwdp8s5stSqqqZcXl8jIKPm3s7MjmOzMSNq+KCg2ak2hwWbCMTExwT8JEgAkZs1IdTERtWja5M+QlX4PUdEq4jRWr0qqFdkI4979AO5lysHP1wflfSuidcfuYi/s2bcfFf0rISAgUCa1tIMTVq9dj81bd8DH1w/f/TCPJE0m/PwDMWjISEyY+DE8ynmjUmAV1KrfTIiXCblVh27w9PIlQr8l7+V3tu3UAx7efkQMKdi6bRc8Pcph6lczUbl6HVSi93n7BuLY8RP4jlQvFzc3BJAk8q1UQ4iUc1w04LrsbG1I1XMhCWABM5JQOSQBbKnMjlQ+d3dX7Nj5CzzKemDm97PRb+AQal81ItBI+FK723fuoV2lmVG8ffzQql0XmTNeEIIaNEd5Hx9Rp8r7+mPytBmiEvKz+/YdQK06QejZZwA8vHyEwHm+23V+BZ40Djye3r4V8M13P8KExoEZhMdjwODh8PYLhI+fH1rQu3iBgPGLwwCMYmGC+Ph4kQKss/7jUB6Rzq9a6XmCFyxaDhNLGzg5Osr3HPVqZWZmihFvjsPs72di9FtjiAhi8cUXk3Bw3694a/x7aNK4EfoNel0Iz8rKGmPHT0CTRvWRQSpWNqlEFhZmotdYlCpNDHMQe/fux/ZtO9CiVVtcOn8Br74+Qt5ja2MjTGls/FglsLW1hZmpuTCkKV0rZe+KSZOmYED/fpjy5TRYkrTq0qMfpn75FVavWYc+/fohNiZGCEgX+mpGNmi1pynMevTYYGeiLe3igSlTpiE4OBhdunaXvhsZm5LktNHexwRqzGU2qjJm1GtXQ3DixAmZz05duuGLTz/CoiXL8e23M+HjUx43Y27hlZ498NaYMfKeug2b4Y8jBzFv/gJcDw9Hj569SHKOxw9zFghjDR05BuvXrkXlKlWxbccOODs50r2LYV3aAS8c5i9Zp9BqqBQF0dHRypUrV5TY2FglKSlJSU1NVdLT04tcX2FAhKeU9QlQAqvXVarWrKdUCKiumJdyoiXITDl5KlghtUVx8/RTAmrUU0i3V0glUcjTo8THJygXLl1Wzl+4qDi4eCi0kkt96ekZirWtg9K8bWftO2b9OI+4yFiZO3+x8iAtTXFw81Kcy/goqXfvqZ9JVxxcvRTP8hXle4u2XZRSdk7KzZgYbR2tO3RTSpV2kfdv3rqd6jNR3nhrvPZ65+59qc0Wyu979qvqpHbzO7z9q0n9T0KvAYMVYxMrZfuuX7RlW7ftVEytHZW6jVtp5yDyRpRiZeustOrQVXtfbOwtaWfT1h3ku5uHj+Jezl/Zsn2XjA2pSfRJVUiNkutj35lIuqSpciUkVL5zW42MzZUOXXvTeCYqF+mZy1dCaCzKKYHV6sg9Ds7lFBcPP6lHg/ZdelJfrZRNW7YrzxvL12zhPy2KJAkU9eoaERGBBNKR2ThTnlMadk6OAitrlR7v4OSETh3b49zZMwiqU0vlpVKboryKsvhu0rIt3NzdUbt2XdSt15hUGi9YW6mMeNbNjYyMScV47LozNTPVfyEq+PuJWsJ9Zt3W0cFeLwtdgSmpKpoxERUx1/VsVPDz1X5zcXYWyeHu7ibfWWLYU52i6xUBj0gd7NiutdY2k1fTMHCbdPslkkXdrm2bN8Da0pxW+p6oVqUK3Mt6oWP3XshR2yRsBxgZmyDl9h35Hh4ZCTsnN1K1IkQNCqrXCEF1G5Pq6CMqXAJ5qtIe3EHtWjVgX9pOOxbt27ahMczEi4RCe4cUtXEZEhKCZDJ4nIjwSjom8DTEkTG4atkCtGnVIpdnQrwtOvcxIXbq3gc3yMg9HXwGVQIriYHMdkFQ/YZyjyoukAMT08d2Tfajv/uys+k+jXdIUbLFENS8l8xFUk+yxHjWlF27dp3UYItcdTzMfOwzz8pW+f81fnSuOzsnm4iu6NrqQ52YgikxmLGRCXlk4rVlTKQZDx9RH1R9dXV1weULwWLb3STDfeeu3/DV9GmiKm5ct5LUyhxxxTra28v9ZcuUQWpSHPr16YWFF06BpCipjOY4e/Y8LMhe4YXRzMoGJCHImH4IC3OVHfDXydPEkCXimS8yCjXKGiIj9Yc8FFGkY5bC84SsLkQo9+7fl++6OvPjVTBHu9o9uH+PdHJrITaemIGvj0SOkTnpurEyWTbUH/YAsZE48/s55NG4Qf54e/2XEkHoN0RF/CyVapB3JjtLEe/UhYuXyc4YiltUn8ZeUrSPKDqPK9ATFaqv+UrXPJ7THRs13EnyOTo7IIL688WX00GqIrrQguDmXkbrsw2sXB3ObmWFUVgSVKd+ZGVlwsFB1f/MjExyy9rh+9nzsGLlWnTq0BZlPb2wbu0arNuwUebgP59NQR2SwBM/niSGevNmTXErJhq9+r2GS5dD5PqG9evJJnDEi4QCM4E+A9ipjdHnCXFxZqfh3r37eV5nokxJSkRSfKy4DBfNn0OqTiYa1q8rxnSlSv4YOfx1XLsULMacvX1pDBgwCNdDQzDx3bex9L+rYWnBqlIObpMrVqH67qYmIf5WrPYdPC6JyQm4nZJEzJWJGdOnIICI6PddO4SQ4uIS0JhcmSm3osQLxQEnRvLt29o64ukeblcGSQ9NuxMS4nAnJfGpfBB3K57UlQxi7gfaMpZuULLELakBG7EbVq+EcU4WJn/+KerVDUL7dm1IGqUjJlrlurx48Qx5psqiTu2asLaxRZ/evclz1Bmzv/tGrr/3zlhazU2xdPFCDB36uqiap0/8IarQq2TIu5Ek+e6bGeg7cCh2b90g47J5/SrUa9AIu3dsR9Uqgdj48wZMfP99pN2J0y5czx1n1QozG8ZvDO37RP++rgrEDGCj9iiwS5LFHkcC+a+FhYWsePydPyUdLyDjk1yT9+Dl5SleGX2wWnH1+nXShc1Q3rucqEQpRHyXKWDjQDZElcoBcs9lWqXcy7jDgZiA72GXYga5Q8vSSmlsaowbN6LIrVlWGCcs7BrMSdz7lvfWjg2rOwqNTwXShzUBr+Cz58Q/Xy+otrhPo2/eRGBAJfGlR9IYsjrB3hIGxw3u3E6Fn5+PjCO36Vp4BHiZ9vfzyTsoxf2/GUteuVR4e5XTzgl76dg97OrqKlFzBqt5zAh3KCZwkfrqQi7WSmTXcDzCmGwgbxo/zVzxip1KdbqTq9bXp7z0j9NF2OPFMQVyKlDw0AR+dE3jDg+9eg3J5FYuW7YMjbOXeOQUtbrIbefxZXurLo0Fl507fxEVKqjsqueJFWu3YkjlAS3zZQINA1y+fJkG/aYMtkYffp5MoOhFJpV8IpUFeYZXYF3Xpj50o8SaZ3OVqe8zKuD784oSa9SYovRF/znde57W97yi3/m9rzhQEnUWBsIEvj1b5muhcCMvXbokEoD93Y90fNI8eJrBV/mdjWV14FWHvSwlCf3BK8hg5vfM0xhAdd34b8/mKkPh3p8X4RWUKArSf92yp91fkMWqJIj1eTKAFg2U/L1DkeQK4+CJG4lHXS8QD5wmkYoZgY1Nvs66Iuu27ClITrlHasVDYoyCd5Y1tGQK71evUon08adHFp+0gpXkCsP9Y2mneYdG1Shu5NW3gqzYJQW2Z3SzAThAZ2b6Ynl5iop8e+Hl5SWDz0SumXwNFHX+CBOCJs1XU2ZtbYmDR88gLiGlwETCK3F8fBL5kpvkywDsluTwPOfirNuwifT8UFiTEdu8eWO0bN6swAlphQWPwU/kDXlnwntYu2YVWrVohpIAEzvbCouWrJB/Dx86WOyS5wVmgNCwq5IF2oGM6ratW+DfgnypkyfA19cXV69eFYLLi6DzIjZTGjROcCttlyV5Pfm+h56/RQwwoE8n1KxeOd/VnBmAk9lq1W2EW1ERsC5lIykOkydlSQrA77s2axmhuLFx6w7Ex0Zh96+/lxgTMKZM/xpLFy0SW+MWeYIWzP3+uUqDMxQD+O7raeSBuv+vYoICj6a/v7+sgro2QbE1Qs0Ando3KxADaPDa0FFISkzCpCnTkJhwCxHkCapUtQ727N6Cz76YKsSiu5lGN8eGyzV90XVD6m/G4X/r9pk9PhvX/hfnL1zCzP+bKtc09ys6G3FU9z6SMt3rWXrX84KizmrlgBUn3nF6985ffhM1U799uu/Pqw3cz0x1EO5v7cs1BrklvMZdK+OmlvKcuMdwdHgBc3+eAYVaUpgR2A4oTkbQMECXji1Qu0bBGYAnN5zciCbmlnilRxfxVLGr9PfdW/HRJ1+gWtUqch+L8UVLV6BqzbpwK+OJyjXrY+1PP2sN+MHDRsM/sLqoU01btsPnk6dTlHQiPMr54ez5C8JIfN/Gzdvg4OIh6sn2nb+ga/dXSC3aJNf4ninTZiCwWh14ePmiYbO22Lf/sFzjdvL1H+fMR0C12tKGmnWbYMu2ndrr+uD+7z1wELGRYRTHGCzSJuZGOA4cPCLPvPP+f+BW1ktbB9fftHUn+AdUl0g1l509dx7u1IchI9+SaO2s2fNRuUYQXN09UYnaOXveIpHWfG+v/q+hRlAThISFSVLcuPc+FG/fvgOHULtBc5Qt54uefQdJJNnY5MXKAC0OFFquVqhQodgkglYCdCAJUC2gUAYtE3HNmtUlANSxW28Me2Ms5i1YgjQKFn01dRL69u4p930y6UuMGjEUzi6umDNnjmy0GTigrxAFI/XeXWSSH7xOUCMKGJ0XwujZrSNib4Zj5ep12vctX7WGfPnJpA+3RgT512+Eh5LPXxWk6t7rVUz67GOKqFpj0ODBCKV4SpvWLbF3/yEhstFj38X4t8dSHKAC5syeLeP3So+uUr9+6rlmPV7+3zU0QGbUj1fQvWsnHi0sX71WrnXp1A4J8bewYdNW+c65+n8eO45wigif4LQEAqeAx1MfJowbgwkffEx/30JAQACWLFkkuUrjxowS/V7GgGIt9yiaXrNGXVy/dg1utOKHke+/TevWuEaM0btPH1LH4jBi5CiU8SreXWsvDIqSRUo2gnLx4kUlNDQ0z090VKSyYfNuZd7idQof+Kv/WbLiZ+XLr+crZy9ckfpIpBfm9XI/iXmlR5+Bip2Du2JsaqnKITC1USoEVpfsx+SUFKWUnaPiX7W2ZJFyRmZGRqbi7V9VcXD1lHr6vjpEsXHyUN4YM15bLz9n5+Su+AbUUEgtkaxTB2d3pVrthnLP1Onf8O4EhVZiJezqdeJcM6V6UBOFFga5vv/AYcXbp6IycMhIhSLEipmVnVKjbhO5xm3grErO2PT0CVQoKJerXzwPcfGJiq29s1JV/b40esbF00/axNmdnO1ajp719Kkk/Vqxcq1ibG6nWNo6KaQGyjO1GzZXXNw9pf7f9+5XTpwKVkgVU8jBoVy+Eirj1XvAYLm3U7feirW9uzLxP59r21GvSSupkySgtozUT+qLg/LRp18o/wY8UxYpgyUCB8cKuvlbFywB4hJIBWrfHDWqFk4CaMDPmNOKumXDaoSFnMehgwcwc9ZsBFapjGSKvo4Z/z4y0kmHNjaXPcM2tvawtXOCvZOrqAz3Um+L3stbM9PvJuO9cWOlXm4H67ytW7fBjWtXJNLLq+vtpDgM6Ndb9W51G0pZW0kWJacp9OrZVVZ19qK1bNEUkSQpVi9fhD1791PU2ULKzUlS2No5wt3DG9lKDhLjOeKdmntsSLXZtn0nHqQ9hA9FpXfu/g179x1EJRrv9LRMbN6yXTbUtCMPTWx0JEV37+H4iRNo2rQJOnbogMOHj4iUvnz+HJq1aCmqUFDtWpj14zySgi7kQLBDvUbN4OMfQPNnqe1PVsZ9jB87Wr5z8l0MRZ3dy7iha+eOWo/f6DeGISv9Nv5teCZHLzPCNRKf7DUq6IYaYQBSgbp2aoHqRWQARlJKClq16SD7bP88+DvcGjdAE/p070y6caVA2TnFBPUoM00yJP84GCtbBzn1gVOqaTUWvZcTw8Tfn5NbNx8yeCAx2FpsJr07lnRhc2tbUaME6uZyegBv4eQCTsJjaFTF3b/8Ds9ynvJ5mHafxsoXRw/8Ru26BXu70rh//77kzzjYP07Q03h+lq9ajfLkkftl927s3LpJrplb2sDbxwcrSIUaNuQ1DOjfC0sXzsWceQtpAThMLtu34ebqiuHDR+F7IviMB3cxsL+qvXUbNEFSUhKWLluG2qRCXiVbqmu37uJKlvdm50gqhCaLleeI09M57yktPQ325qo92pym8W88peeZe1QYiaCRAJ3VDMBpCkV1YbqSXpujGOPU8T/x+og3aYJi5DN5+gxJQa4SGCD5+e5lyuDUXydwJTQMVSsHIjExEU2atsKwEaPVNT1OHdBFO3IBunn6YtmKVfiZjOL6REheRNC64DykoNo1YVnKHj9v3ILdv+0RQho+aiy6d+uMzyZPletObq44euQP3KTVldsQHhGORk2b462338m1eDADcJ7+mdPBRJTGCLl8DiFXLiE09Ar14ahIjb/+/AuRN6LQuEF90s8rYOWan8h/fw31g+qgVvVquHvvPuYvWgrHMl5o0awxbt/mfJ84kYBdOnUgu8QXm7Zso3E3w3WWYgRLK07zViRBkMF2TMsWzXH/borsDuOcIXYcjJvwPtXrjX8lnmVnmQb6NoK+TSA2wIz5yrmLqp1J2dmFswH0wbp7UnKyUrFKbdlJxh9jU9WHd4ZlZan084gbN5Qynt5iLzi6lCGuM1HsncsoIWFX5XqTlh3k2ungc7nqZgwZ+SbVay76/5LlK7XX3/vgE3nmh7kL5PuuX35TrO0cpMzCspS8o3b95qKvMy5dvqI4u3nIdSduA4wVlzJeSnT0zb/1a/CwUXLfux9+8rdr5KGRayPfHCffXx08Qvrt7O4h7+I5LEd2Ao8BOQu0z40aM4HuMyXbyUWxLmWrdOzeRwlq2FLq2rZjN9lVr0qbaKHQ9p/tjqq16ku5qUUpGYPuvQeQnWBN7x+v/BugsQmKLe79NNVIowJ1YwlQpWK+iWoFAa/cvI849OJpHDxyFOfPX5I6g+rURoN6Qdrsx/IU8Y68HoYdu39FBHlRytCq3LO7yqXKmPTph7javw/Kl/fS1q2RTtOnfI4mjRrJZpJXyR7QtJvVIm9vL7Rv10ru69ShHcKvhmDHrl8li7Na1aoSTFLU6SSVSSpFhoeRfv8roqNj4OnpgR4kKSxJgvJZSaY6m+k7d+yA5rSCd+/a+W99/mHmV5LHb69WoWZMn4ymjRuiUqWK2iDm2tUrKIZxkaLureU7p5AvmPMdevfqjtOnz0g/+5HHKTY2Dpu2bpO0ck4h79i+Hcq6u8sz3G5Oe7kQfFxcw5zR2r5NK9QiVWoueeA4M/bfhAKlUhcGGkawL22LYycvITnlLpKSb6NHl1akChQPA2igPCHjUlEdLSGde9I9mqCTbgRcc84OQz9XRlMvl+s+w+kbmmeelNWZVxtkGdYbC/136kaH9Zklkzf/6yw2cpobvUe3bZq8Jv0oc1590233k9qsOz4llTP1T0KySF/t0bLYrRyNjcAroOooj0R066xmAKX4GIDxpNwgIyMjbUbnk+7RBMFylenclxeRcD36z5ioc+bzytI00mGOv13H37NW9d+pS7i6DMCw0JO2msBXrjL1d/3F7WnH4jytzbrj87/OALooEVOfGcGK1I24uER079L6sQr0IqTOGmCAHkqEnVmUuruXRbs2jVHBt7yIatN/+FAuAwwoKIpdEmh0yqN/BmPj1r0SzGEGeJ4nUhhQslAUJVcCXlFTavQTF59yp953jvHoHzpQcHorVibQ+P2PnTiLw3+chKO9LRYu20Aek/uilxoY4d8JzcK3iwKE+w4cLJK9wIzDNHKVHCvLV65+ylH6HI8iss2KoYjpLCDjIn03UZ3RpNAzKYuAu9tU9xSQEYqNCRS10Xv0eDAOHP4Lbi5OcqaNnW0pLFj6k0iEkmYEpYjnf+k/pxS1opcQGs/T4OGjKRjXnoJ366Vcfwxz9FK19etgxjl2/C9UrlwVH374UZ5MoKIdcgik/QWcpsBl+AQguBoR/mKy5IkRzrkAV0cBl3sAYXyWFJN3/nNZLEygkQB//BWMw0dPCAPIiQPqk9j4VIEFy9YTIxSfRNDUcfvOXZy9EIqUlDtyBLqmnLNTz1F5RkZmrvuvXY+i6Od17SCrJkeVZx8SFi4R1xdi7+v/CORI+6Rk7N+/D5WqBWHh3FlSzuO9d/9BUDBOfuSEnSLsMdRIjWMU+d64eStiYmLVh5gpWErRecXYDGvXrNYe7c/nQW3dsUtSXmR/CBdGDVK/HCqrNupDkgqzAYpsC0XzJ+k4Mctx5L/zuxgMY10JcPjoKWIA59xcz4xgaoLSzAgkEUYN7wt7O7tn3iHFz164FIb1m3bDt3w5Cvz8Jq7YurWrYv+h4zh05CQ8PNzw89Zf8c5br8PZyR4LlqzHvQcPYGVpge27D1D5IO1gr/5pJ85fCkH/3p1Rr041GFAwMEH3HzycYkNZyHyYLCdhb16/Gj4VqyA6PFTusSntiC2bN8kpgRxDataqA04cOwxWV0wtS2Hp0iUIqlUTyxbORb0mrdChYxdkpqVi4JCR+Hn9WuRkUQDW0oYkxIf48otPkZ1xCybVT6pOsjOi+cu5S3WRHdLgAv37AWDuR6sdSYKHkYB1g3z78EySQCMBVAxwEq4ujrkYQAMuYYlQ2s4GC5duKBbViJ/dvH0PieBWGDa4F/r16oj9h4/LeUG/7DmCsaMHgQOATRvVwbZdeylCmoDrkTcw7s1BGDtqoEiNU2cuS12Hj52SYwZrVg80eLGKgFXLFqKUrR3cXN2w6adVqFargZx4zbvvomNi0KxFa3Tu3Fl2y/V9dajkQx0+elSOaR8+/A28PvBVOeRswvsfI/jUKZw8cQyTp/4f1q9ZhW7de2MPHwsfVA9TJ3+Gn7YehknltUBEHyIqZyJ0msO0PwFLWriS55K25AGkbuIDWQH7/shPHVq9+qeiM4FGAhw5dlotAZyeqkurVCMTYYQFS9fjzt27z8QIzHwfThiOerVVqzarOF6eZZGQkAJXVye4OKu2ANasFogb0bGwt7fDtM8nSGrxvfuqLFLf8p7ywxW/7TmKYa+9IudpmpgamKAw4Pkr4+4mwTu70nZy0FjolXNyMO/mrduxYNFSmeeHGWn4Ye4ChIWFoWJAZSHsr7/9kdTVdDk2fsPmLWjYqB5VmEX1ucuuufL+Adi8YZVIkF1b1sPazhnLFn1NK303wJvsgJiRxAThgPN4Ws5t6S/ZCLfeBdJJSlTh5ECmraerQ6+NfLNo6pAm9YHdoEeOnZSTznIKYEw+lgi2IhGeRTVihtOoMqvWbUf4jWh8OnE0wq5G/r3biup/fIoap3B888NStGvVGGXLuGLazIXo0bU10tIzZf/w7ZRU7UkWBuQPzT5uJUd1YC/naxmRmvKI/vJ+jUSyFzg/qV69OnJaxkP55ZtHsu+Zf0WnfHlvfPPtd/LDIJz+zr+3IEdVKnyQsKnOAWEcbJVdU6oX27RRfVRXVX8s/AGvDeqyJ5/Tqgt3d+fCSwKNBGAV4vAfKhugMN4Ulgh8dLdGNbqTWjSJwM/wgM9ZsEZUmUkfjZF0AAcHO8QnJCFZfYT4xZCrIgWsra0QcjUcP85fhTeG9EPrFg1JIjyQjTnBZ69w/pT8EMeRP0/jSuh1GFA4MAXw8e38azl+FSsiIiIcrw3qj0mffCRzlZiQLEmI/hV8cS3sMjq2a4OZM6bC2dERl66EoHPHdnJ6SA65Ofkw3y6dO+D61UvyQyV/Hj+B3gMG435qEvr1fSWPt2usYd3lzwgF0fZN5b9Cgjlzy8595M4KJh3QSUtshYexZDj+37eL8ebIAfAuV/gzdb6etURsAAeH0li6ciOyaIUZPaI/2rZsjFlzVsLbuyzCI6Lx3ttDRSWaNXclAiv64vTZi9i47Ve0at4QE8cP03ospnw1Fx3aNkPVQP/nfkTg/xJ4DUxIiCfJbC7jdmjvb7KRp0pgoFy3sLQmtWix/Hvrz+vQuEU7tGzeVL6bmlngvQ8+UuWZxSUgOysDEZGRsk/8VPAZ/LRqBX2WyX3jJnyAEUMGF+uxMwf27Ch8FinrzaHXIuFIhCciEM8CIxGlvCEngIizMODBjoi8SfqkEbIeqcSxkRyK6yX9uBkbRytLshA9S4E7qffkO/90EUsQ/g0Bd1dn8ho9Pj7kWniUfOcMWAMKDp4LPpiLNwJV8PPT/uDfvoOHZYtrsyYNaaFyEBWIJS/P0+Gjx+THDDn1nQ8Elh8STEiUo+EDAiqK7cbzePzESTlSvmaN6gisVPGpGbCFhSaLtNhTqYsKdfZzgaGb1purHLz9I3ddT1s5NCu+bn0GKVA46I6vymOYd+r60+aAkd8By8U9L8wEg/p2afnC5MMWtm9PykiVYda79DTm1h6s+5TDaw14OnTH90mp8gWZg6KUPSvk3CYYYMBLDgMTGPDSw8AEBrz0MDCBAS89DExgwEsPYQJ2UBkb0gQMeMmg8TWJi5Tdg+EUeDLs/DLgZQEH4zhjgSFMQBG4kK079hbeWW+AAf+j4AwDW1sbOaP1/wGInKmArWvnoAAAAABJRU5ErkJggg==",
    caption: "Platinum Trusted Service Award"
  }
];

// src/components/StarRatingIntervention/StarRatingImages.tsx
import { jsx as jsx28 } from "react/jsx-runtime";
var StarRatingImages = () => /* @__PURE__ */ jsx28("div", { className: "star-rating__images", children: StarRatingImageData.map(({ imageSrc, caption }, index) => /* @__PURE__ */ jsx28(
  Image3,
  {
    src: imageSrc,
    alt: caption,
    className: "star-rating__image"
  },
  index
)) });
var StarRatingImages_default = StarRatingImages;

// src/components/StarRatingIntervention/StarRatingIntervention.tsx
import { jsx as jsx29, jsxs as jsxs17 } from "react/jsx-runtime";
var StarRatingIntervention = (props) => {
  const { onDismiss } = props;
  const [hidden, setHidden] = useState17(false);
  const handleClose = () => {
    setHidden(true);
    if (onDismiss) onDismiss();
  };
  return /* @__PURE__ */ jsxs17(StickyFooter, { hidden, className: "star-rating", children: [
    /* @__PURE__ */ jsxs17("div", { className: "star-rating__text", children: [
      /* @__PURE__ */ jsxs17(
        "div",
        {
          className: "star-rating__text-container",
          "data-testid": "star-rating__text-container",
          children: [
            /* @__PURE__ */ jsx29(
              Icon10,
              {
                icon: lightbulbOn4,
                size: "md",
                className: "star-rating__icon",
                "data-testid": "star-rating__icon"
              }
            ),
            /* @__PURE__ */ jsx29(
              StickyFooterCloseButton,
              {
                onClose: handleClose,
                className: "mobile-button",
                testId: "close-mobile"
              }
            )
          ]
        }
      ),
      /* @__PURE__ */ jsx29(
        StickyFooterText,
        {
          headlineText: "Join thousands of our happy customers!",
          descriptionText: "Small business owners just like you give us a 4.8 out of 5 star rating on Feefo."
        }
      )
    ] }),
    /* @__PURE__ */ jsx29(StarRatingImages_default, {}),
    /* @__PURE__ */ jsx29(
      StickyFooterCloseButton,
      {
        onClose: handleClose,
        className: "desktop-button",
        testId: "close-desktop"
      }
    )
  ] });
};

// src/components/TradeSocialProofingIntervention/TradeSocialProofingIntervention.tsx
import { useState as useState18 } from "react";
import { lightbulbOn as lightbulbOn5 } from "@simplybusiness/icons";
import { Icon as Icon11 } from "@simplybusiness/mobius";
import { jsx as jsx30, jsxs as jsxs18 } from "react/jsx-runtime";
var TradeSocialProofingIntervention = (props) => {
  const { onDismiss } = props;
  const [hidden, setHidden] = useState18(false);
  const handleClose = () => {
    setHidden(true);
    if (onDismiss) onDismiss();
  };
  return /* @__PURE__ */ jsxs18(StickyFooter, { hidden, children: [
    /* @__PURE__ */ jsxs18("div", { className: "trade-social-proofing__text", children: [
      /* @__PURE__ */ jsx30(
        Icon11,
        {
          icon: lightbulbOn5,
          size: "md",
          className: "trade-social-proofing__text-icon",
          "data-testid": "trade-social-proofing__text-icon"
        }
      ),
      /* @__PURE__ */ jsx30(
        StickyFooterCloseButton,
        {
          onClose: handleClose,
          className: "mobile-button",
          testId: "close-mobile"
        }
      ),
      /* @__PURE__ */ jsx30("div", { className: "trade-social-proofing__text-main-block", children: /* @__PURE__ */ jsx30(
        StickyFooterText,
        {
          headlineText: "Feel the best about your business insurance:",
          descriptionText: "Compare quotes from a panel of leading insurers \u2013 all in one place."
        }
      ) })
    ] }),
    /* @__PURE__ */ jsx30(
      StickyFooterCloseButton,
      {
        onClose: handleClose,
        className: "desktop-button",
        testId: "close-desktop"
      }
    )
  ] });
};

// src/interventions/IntentCoverageDiagnosisIntervention/IntentCoverageDiagnosisIntervention.tsx
import { useEffect as useEffect17, useState as useState19 } from "react";
import { jsx as jsx31 } from "react/jsx-runtime";
var IntentCoverageDiagnosisIntervention = (props) => {
  const { answer: intent } = useChopinQuestion("what_are_you_here_to_do");
  const [show, setShow] = useState19(false);
  useEffect17(() => {
    setShow(intent == "find_what_insurance_needed");
  }, [intent, setShow]);
  return show ? /* @__PURE__ */ jsx31(CoverageDiagnosis, { ...props, initialShow: true }) : null;
};

// src/interventions/IntentPricingNudge/IntentPricingNudge.tsx
import { useCallback as useCallback7, useEffect as useEffect18, useState as useState20 } from "react";
import { Modal as Modal5 } from "@simplybusiness/mobius";
import { jsx as jsx32, jsxs as jsxs19 } from "react/jsx-runtime";
var CustomPricingNudge = (props) => {
  const { fireEvent } = props;
  const [showModal, setShowModal] = useState20(false);
  const showIPWidgetCallback = useCallback7(() => {
    fireEvent("hydra_ip_cta_clicked");
    window.showIndicativePricingPopup();
    setShowModal(false);
  }, [fireEvent]);
  const showNudge = useCallback7(() => {
    fireEvent("hydra_ip_modal_viewed");
    setShowModal(true);
  }, [fireEvent]);
  useEffect18(() => {
    window.addEventListener("intent_idea_of_price_selected", showNudge);
    return () => {
      window.removeEventListener("intent_idea_of_price_selected", showNudge);
    };
  }, [showNudge]);
  return /* @__PURE__ */ jsxs19(
    Modal5,
    {
      "data-testid": "intent-pricing-nudge-modal",
      isOpen: showModal,
      onClose: () => {
        fireEvent("hydra_ip_closed_banner");
        setShowModal(false);
      },
      animation: "fade",
      closeLabel: "Close",
      children: [
        /* @__PURE__ */ jsx32(Modal5.Header, { children: "\xA0" }),
        /* @__PURE__ */ jsx32(Modal5.Content, { children: /* @__PURE__ */ jsx32(
          PricingNudge,
          {
            onPriceEstimateButtonClickedCallback: showIPWidgetCallback
          }
        ) })
      ]
    }
  );
};
var IntentPricingNudge = (props) => /* @__PURE__ */ jsx32(RenderWhenIPWidgetLoaded, { children: /* @__PURE__ */ jsx32("div", { id: "priceNudgeIntervention", children: /* @__PURE__ */ jsx32(CustomPricingNudge, { ...props }) }) });
export {
  CoverageDiagnosis,
  DiscountVoucherIntervention,
  EventEmitter,
  IntentCoverageDiagnosisIntervention,
  IntentPricingNudge,
  Intervention,
  InterventionWrapper,
  Interventions,
  InterventionsProvider,
  QCPInactivityIntervention,
  ReassuranceIntervention,
  StarRatingIntervention,
  TradeSocialProofingIntervention,
  useInterventions
};
